/* webpack-ignore */
var log = console.log;

function loadXMLDoc(source, callback) {
    var request = new XMLHttpRequest();

    request.onreadystatechange = function() {
        if (request.readyState === 4 && request.status === 200 && callback) {
            callback(request.responseText);
        }
    };
    request.open('GET', source, true);
    request.send();
    return;
}
NodeList.prototype.forEach = function(callback) {
    Array.prototype.forEach.call(this, callback);
}

function fadeIn(el) {
    el.style.opacity = 0;
    var last = +new Date();
    var tick = function() {
        el.style.opacity = +el.style.opacity + (new Date() - last) / 400;
        last = +new Date();

        if (+el.style.opacity < 1) {
            (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
        }
    };

    tick();
}

var tollMap = {
    api: null,
    map: null,
    exitSelected: false,
    options: {
        credentials: 'AhZV-7p6O0GkB7SWeEMYX3AGi9jxHMOaI7H9aqlymzHRWRomi3YMKxf3G4jzmnCp',
        center: null,
        centerOffset: null,
        mapTypeId: null,
        //maxBounds: null,
        //maxBounds: Microsoft.Maps.LocationRect.fromLocations(new Microsoft.Maps.Location(35.097755, -80.675268), new Microsoft.Maps.Location(34.984264, -80.401854)),
        navigationBarMode: null,
        allowInfoboxOverflow: false,
        showMapTypeSelector: false,
        disableStreetside: true,
        showTrafficButton: true,
        showScalebar: false,
        enableSearchLogo: false,
        enableHighDpi: true,
        liteMode: false,
        customMapStyle: {
            'elements': {
                'area': {
                    'fillColor': '#d0f8d0',
                },
                'water': {
                    'fillColor': '#dce9ee',
                },
                'tollRoad': {
                    'fillColor': '#092940',
                }, //#d0f8d0
                'controlAccessHighway': {
                    'fillColor': '#092940',
                }, //#d0f8d0
                'arterialRoad': {
                    'fillColor': '#dce9ee',
                    'strokeColor': '#95a0ad',
                },
                'road': {
                    'fillColor': '#dce9ee',
                    'strokeColor': '#95a0ad',
                },
                'street': {
                    'fillColor': '#dce9ee',
                },
                'transit': {
                    'fillColor': '#092940',
                },
            },
            'settings': {
                'landColor': '#efe9e1', //#efe9e1 ecf0f3
            },
        },
        minZoom: 7,
        maxZoom: 14,
        zoom: 8,
    },
    data: {
        zonePinLayer: null,
        expDataLayer: null,
        expExitDataLayer: null,
        expTollLayer: null,
        //vcOneRate : { // could set the multipliers right here
        //  bbm : 4.97,
        //  ncqp : 3.25
        //},
        type: { // don't need this anymore
            entry: 'entry',
            exit: 'exit',
        },
        // revise order of exit feature data or find way to sort two different segments!
        triExpGeoJson: {
            'type': 'FeatureCollection',
            'features': [{
                    'type': 'Feature',
                    'properties': {
                        'strokeColor': '#0079c2',
                        'strokeThickness': 5,
                        'routeSegment': 'Toll line - 5a to merge',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': [
                            [-78.87386, 35.903054],
                            [-78.87513, 35.90108],
                            [-78.87604, 35.89906],
                            [-78.87632, 35.89749],
                            [-78.87632, 35.89678],
                            [-78.87621, 35.89611],
                            [-78.8759, 35.89525],
                            [-78.87551, 35.89449],
                            [-78.87092, 35.88676],
                            [-78.86966, 35.88445],
                            [-78.86812, 35.88091],
                            [-78.86742, 35.87879],
                            [-78.86685, 35.87658],
                            [-78.86346, 35.85792],
                            [-78.86318, 35.85507],
                            [-78.86313, 35.85411],
                            [-78.86318, 35.85317],
                            [-78.8635, 35.85214],
                            [-78.86407, 35.85119],
                            [-78.86491, 35.85029],
                            [-78.86612, 35.84918],
                            [-78.86697, 35.84858],
                            [-78.8684, 35.8478],
                            [-78.87003, 35.84718],
                            [-78.8703, 35.84711],
                            [-78.88024, 35.84442],
                            [-78.88161, 35.84386],
                            [-78.88411, 35.84257],
                            [-78.88641, 35.84094],
                            [-78.8877, 35.83979]
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'strokeColor': '#0079c2',
                        'strokeThickness': 5,
                        'routeSegment': 'Toll line - 69 to 54a',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': [
                            [-78.840237, 35.863331],
                            [-78.84484, 35.86153],
                            [-78.8452, 35.86144],
                            [-78.85338, 35.85929],
                            [-78.85484, 35.85876],
                            [-78.85575, 35.85831],
                            [-78.85696, 35.85748],
                            [-78.85764, 35.8569],
                            [-78.86486, 35.8499],
                            [-78.86636, 35.84868],
                            [-78.86723, 35.84816],
                            [-78.86889, 35.84747],
                            [-78.8765, 35.84548],
                            [-78.88024, 35.84442],
                            [-78.88131, 35.844],
                            [-78.88307, 35.84314],
                            [-78.88411, 35.84257],
                            [-78.88545, 35.84168],
                            [-78.887292, 35.840173],
                            [-78.88733, 35.84014],
                            [-78.88851, 35.83892],
                            [-78.88934, 35.83789],
                            [-78.8904, 35.83626],
                            [-78.89085, 35.83534],
                            [-78.89225, 35.83207],
                            [-78.8935, 35.82884],
                            [-78.89382, 35.82723],
                            [-78.8939, 35.82583],
                            [-78.89379, 35.82456],
                            [-78.89359, 35.82346],
                            [-78.89263, 35.81973],
                            [-78.89247, 35.81821],
                            [-78.89249, 35.8091],
                            [-78.89242, 35.80701],
                            [-78.89229, 35.80608],
                            [-78.88673, 35.78394],
                            [-78.88609, 35.78164],
                            [-78.88575, 35.7797],
                            [-78.88584, 35.77099],
                            [-78.88607, 35.76947],
                            [-78.88658, 35.76809],
                            [-78.89111, 35.75989],
                            [-78.89169, 35.75823],
                            [-78.89187, 35.75729],
                            [-78.892, 35.75501],
                            [-78.89223, 35.73448],
                            [-78.89223, 35.73296],
                            [-78.89203, 35.73153],
                            [-78.89166, 35.73037],
                            [-78.89111, 35.72927],
                            [-78.88786, 35.72436],
                            [-78.88674, 35.72233],
                            [-78.88588, 35.7205],
                            [-78.88319, 35.71416],
                            [-78.88232, 35.71235],
                            [-78.88115, 35.71024],
                            [-78.88011, 35.70862],
                            [-78.87192, 35.69714],
                            [-78.8695, 35.69387],
                            [-78.86837, 35.6926],
                            [-78.8669, 35.69135],
                            [-78.86525, 35.69033],
                            [-78.86424, 35.68983],
                            [-78.86289, 35.68931],
                            [-78.86062, 35.68871],
                            [-78.85828, 35.68842],
                            [-78.85828, 35.68842],
                            [-78.84753, 35.68804],
                            [-78.84013, 35.68803], // exit 54
                            [-78.83120, 35.68658],
                            [-78.82817, 35.68595],
                            [-78.82557, 35.68466],
                            [-78.82195, 35.68047],
                            [-78.81881, 35.67693],
                            [-78.81649, 35.67540],
                            [-78.81416, 35.67447],
                            [-78.81050, 35.67359],
                            [-78.80606, 35.67339],
                            [-78.80094, 35.67468],
                            [-78.79783, 35.67539],
                            [-78.79344, 35.67538], // exit 50
                            [-78.78313, 35.67529],
                            [-78.77652, 35.67598],
                            [-78.77081, 35.67704],
                            [-78.76602, 35.67731],
                            [-78.75776, 35.67664],
                            [-78.74442, 35.67495], // exit 47
                            [-78.73807, 35.67333],
                            [-78.72208, 35.66744],
                            [-78.71824, 35.66324],
                            [-78.71509, 35.66057],
                            [-78.71038, 35.65752],
                            [-78.70538, 35.65539], // exit 45
                            [-78.69900, 35.65344],
                            [-78.69490, 35.65261],
                            [-78.68808, 35.65187],
                            [-78.68250, 35.65061],
                            [-78.67935, 35.64988],
                            [-78.66922, 35.64664], // exit 43
                            [-78.66354, 35.64368],
                            [-78.66042, 35.64187],
                            [-78.65834, 35.63882],
                            [-78.64963, 35.63614],
                            [-78.64514, 35.63508],
                            [-78.63617, 35.62959],
                            [-78.62878, 35.62583],
                            [-78.62186, 35.62325],
                            [-78.61874, 35.62213],
                            [-78.61650, 35.62189],
                            [-78.61650, 35.62189],
                            [-78.61453, 35.62181],
                            [-78.61194, 35.62210],
                            [-78.60644, 35.62301], // exit 39
                            [-78.60100, 35.62412],
                            [-78.59660, 35.62487],
                            [-78.59516, 35.62530],
                            [-78.58695, 35.62871],
                            [-78.56613, 35.63536], // exit 36
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit5',
                        'exitName': 'Exit 5 - TOLL N.C. 147 at I-40',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.8750862724293,
                            35.90068229286277,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit3/2',
                        'exitName': 'Exit 3/2 - Hopson Road / Davis Drive',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.86560992554514,
                            35.87052593706993,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit69',
                        'exitName': 'Exit 69 - Chapel Hill Road / N.C. 54',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.84517930536364,
                            35.86130264926182,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit66',
                        'exitName': 'Exit 66 - N.C. 55',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.88652067271332,
                            35.840638288996104,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit64',
                        'exitName': 'Exit 64 - Morrisville Parkway',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.892294,
                            35.809137,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit62',
                        'exitName': 'Exit 62 - Green Level West Road',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.88631693923891,
                            35.78325305115886,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit59',
                        'exitName': 'Exit 59 - U.S. 64',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.8918710118596,
                            35.747012840173205,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit57',
                        'exitName': 'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.8801149970323,
                            35.70890424458235,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit56',
                        'exitName': 'Exit 56 - U.S. 1',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.87168213188947,
                            35.697130249690304,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit55',
                        'exitName': 'Exit 55 - Veridea Parkway',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.86196064247461,
                            35.68915803591623,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit54',
                        'exitName': 'Exit 54 - N.C. 55',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.84013618411323,
                            35.688038309321506,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit50',
                        'exitName': 'Exit 50 - Holly Springs Rd.',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.79344,
                            35.67538
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit47',
                        'exitName': 'Exit 47 - Bells Lake Rd.',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.74442,
                            35.67495,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit45',
                        'exitName': 'Exit 45 - U.S. 401',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.70538,
                            35.65539
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit43',
                        'exitName': 'Exit 43 - Old Stage Rd.',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.66922,
                            35.64664,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit39',
                        'exitName': 'Exit 39 - N.C. 50',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.60644,
                            35.62301
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit36',
                        'exitName': 'Exit 36 - I-40',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.56613,
                            35.63536
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'title': 'NC Quick Pass Customer Service Center',
                        //"subTitle": "Customer Service Center",
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -78.82312,
                            35.85952,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'zoneId': 'gantryZones',
                        'routeName': 'Triangle Expressway',
                    },
                    'geometry': {
                        'type': 'MultiPoint',
                        'coordinates': [ // Tolls
                            [-78.86686, 35.87923],
                            [-78.86794, 35.87904],
                            [-78.86348, 35.85031],
                            [-78.86505, 35.85016],
                            [-78.85854, 35.85761],
                            [-78.85689, 35.85641],
                            [-78.85758, 35.85695],
                            [-78.85733, 35.85766],
                            [-78.88841, 35.79222],
                            [-78.88879, 35.79214],
                            [-78.89147, 35.75207],
                            [-78.8922, 35.7527],
                            [-78.88415, 35.71741],
                            [-78.88451, 35.71731],
                            [-78.88079, 35.71069],
                            [-78.88178, 35.70847],
                            [-78.86047, 35.69029],
                            [-78.86017, 35.68822],
                            [-78.84966, 35.68844],
                            [-78.84966, 35.68812],
                            [-78.71686, 35.66198] // New toll, between exit 47 and 45
                        ],
                    },
                },
            ],
        },
        triExpTollJson: {
            'routeDir': {
                'northbound': [
                    {
                        'entryPoint': 'Exit 36 - I-40',
                        'exitPoint': [
                            'Exit 39 - N.C. 50',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.60, 1.60, 2.12, 2.77, 3.45, 4.19, 4.71, 4.71, 5.03, 5.96, 5.96, 6.42, 6.97, 7.78, 8.24, 8.24],
                        'tollRateBBM': [1.20, 3.20, 4.24, 5.54, 6.90, 8.38, 9.42, 9.42, 10.06, 11.92, 11.92, 12.84, 13.94, 15.56, 16.48, 16.48],
                        'tollRateSavings': [0.60, 1.60, 2.12, 2.77, 3.45, 4.19, 4.71, 4.71, 5.03, 5.96, 5.96, 6.42, 6.97, 7.78, 8.24, 8.24]
                    },
                    {
                        'entryPoint': 'Exit 39 - N.C. 50',
                        'exitPoint': [
                            'Exit 43 - Old Stage Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [1.00, 1.52, 2.17, 2.85, 3.59, 4.11, 4.11, 4.43, 5.36, 5.36, 5.82, 6.37, 7.18, 7.64, 7.64],
                        'tollRateBBM': [2.00, 3.04, 4.34, 5.70, 7.18, 8.22, 8.22, 8.86, 10.72, 10.72, 11.64, 12.74, 14.36, 15.28, 15.28],
                        'tollRateSavings': [1.00, 1.52, 2.17, 2.85, 3.59, 4.11, 4.11, 4.43, 5.36, 5.36, 5.82, 6.37, 7.18, 7.64, 7.64]
                    },
                    {
                        'entryPoint': 'Exit 43 - Old Stage Rd.',
                        'exitPoint': [
                            'Exit 45 - U.S. 401',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.52, 1.17, 1.85, 2.59, 3.11, 3.11, 3.43, 4.36, 4.36, 4.82, 5.37, 6.18, 6.64, 6.64],
                        'tollRateBBM': [1.04, 2.34, 3.70, 5.18, 6.22, 6.22, 6.86, 8.72, 8.72, 9.64, 10.74, 12.36, 13.28, 13.28],
                        'tollRateSavings': [0.52, 1.17, 1.85, 2.59, 3.11, 3.11, 3.43, 4.36, 4.36, 4.82, 5.37, 6.18, 6.64, 6.64]
                    },
                    {
                        'entryPoint': 'Exit 45 - U.S. 401',
                        'exitPoint': [
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.65, 1.33, 2.07, 2.59, 2.59, 2.91, 3.84, 3.84, 4.30, 4.85, 5.66, 6.12, 6.12],
                        'tollRateBBM': [1.30, 2.66, 4.14, 5.18, 5.18, 5.82, 7.68, 7.68, 8.60, 9.70, 11.32, 12.24, 12.24],
                        'tollRateSavings': [0.65, 1.33, 2.07, 2.59, 2.59, 2.91, 3.84, 3.84, 4.30, 4.85, 5.66, 6.12, 6.12]
                    },
                    {
                        'entryPoint': 'Exit 47 - Bells Lake Rd.',
                        'exitPoint': [
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.68, 1.42, 1.94, 1.94, 2.26, 3.19, 3.19, 3.65, 4.20, 5.01, 5.47, 5.47],
                        'tollRateBBM': [1.36, 2.84, 3.88, 3.88, 4.52, 6.38, 6.38, 7.30, 8.40, 10.02, 10.94, 10.94],
                        'tollRateSavings': [0.68, 1.42, 1.94, 1.94, 2.26, 3.19, 3.19, 3.65, 4.20, 5.01, 5.47, 5.47]
                    },
                    {
                        'entryPoint': 'Exit 50 - Holly Springs Rd.',
                        'exitPoint': [
                            'Exit 54 - N.C. 55',
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.74, 1.26, 1.26, 1.58, 2.51, 2.51, 2.97, 3.52, 4.33, 4.79, 4.79],
                        'tollRateBBM': [1.48, 2.52, 2.52, 3.16, 5.02, 5.94, 5.02, 7.04, 8.66, 9.58, 9.58],
                        'tollRateSavings': [0.74, 1.26, 1.26, 1.58, 2.51, 2.51, 2.97, 3.52, 4.33, 4.79, 4.79]
                    },
                    {
                        'entryPoint': 'Exit 54 - N.C. 55',
                        'exitPoint': [
                            'Exit 55 - Veridea Parkway',
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.52, 0.52, 0.84, 1.77, 1.77, 2.23, 2.78, 3.59, 4.05, 4.05],
                        'tollRateBBM': [1.04, 1.04, 1.68, 3.54, 4.46, 5.56, 7.18, 8.10, 8.10],
                        'tollRateSavings': [0.52, 0.52, 0.84, 1.77, 1.77, 2.23, 2.78, 3.59, 4.05, 4.05]
                    }, {
                        'entryPoint': 'Exit 55 - Veridea Parkway',
                        'exitPoint': [
                            'Exit 56 - U.S. 1',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.35, 0.67, 1.60, 1.60, 2.06, 2.61, 3.42, 3.88, 3.88],
                        'tollRateBBM': [0.70, 1.34, 3.20, 3.20, 4.12, 5.22, 6.84, 7.76, 7.76],
                        'tollRateSavings': [0.35, 0.67, 1.60, 1.60, 2.06, 2.61, 3.42, 3.88, 3.88]
                    }, {
                        'entryPoint': 'Exit 56 - U.S. 1',
                        'exitPoint': [
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.32, 1.25, 1.25, 1.71, 2.26, 3.07, 3.53, 3.53],
                        'tollRateBBM': [0.64, 2.50, 2.50, 3.42, 4.52, 6.14, 7.06, 7.06],
                        'tollRateSavings': [0.32, 1.25, 1.25, 1.71, 2.26, 3.07, 3.53, 3.53]
                    }, {
                        'entryPoint': 'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                        'exitPoint': [
                            'Exit 59 - U.S. 64',
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [1.25, 1.25, 1.71, 2.26, 3.07, 3.53, 3.53],
                        'tollRateBBM': [2.50, 2.50, 3.42, 4.52, 6.14, 7.06, 7.06],
                        'tollRateSavings': [1.25, 1.25, 1.71, 2.26, 3.07, 3.53, 3.53]
                    }, {
                        'entryPoint': 'Exit 59 - U.S. 64',
                        'exitPoint': [
                            'Exit 62 - Green Level West Road',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.56, 1.02, 1.57, 2.38, 2.84, 2.84],
                        'tollRateBBM': [1.12, 2.04, 3.14, 4.76, 5.68, 5.68],
                        'tollRateSavings': [0.56, 1.02, 1.57, 2.38, 2.84, 2.84]
                    }, {
                        'entryPoint': 'Exit 62 - Green Level West Road',
                        'exitPoint': [
                            'Exit 64 - Morrisville Parkway',
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.46, 1.01, 1.82, 2.28, 2.28],
                        'tollRateBBM': [0.92, 2.02, 3.64, 4.56, 4.56],
                        'tollRateSavings': [0.46, 1.01, 1.82, 2.28, 2.28]
                    }, {
                        'entryPoint': 'Exit 64 - Morrisville Parkway',
                        'exitPoint': [
                            'Exit 66 - N.C. 55',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.55, 1.36, 1.82, 1.82],
                        'tollRateBBM': [1.10, 2.72, 3.64, 3.64],
                        'tollRateSavings': [0.55, 1.36, 1.82, 1.82]
                    }, {
                        'entryPoint': 'Exit 66 - N.C. 55',
                        'exitPoint': [
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.81, 1.27, 1.27],
                        'tollRateBBM': [1.62, 2.54, 2.54],
                        'tollRateSavings': [0.81, 1.27, 1.27]
                    }, {
                        'entryPoint': 'Exit 69 - Chapel Hill Road / N.C. 54',
                        'exitPoint': [
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [1.01, 1.01],
                        'tollRateBBM': [2.02, 2.02],
                        'tollRateSavings': [1.01, 1.01],
                    }, {
                        'entryPoint': 'Exit 3/2 - Hopson Road / Davis Drive',
                        'exitPoint': [
                            'Exit 5 - TOLL N.C. 147 at I-40'
                        ],
                        'tollRateTA': [0.46],
                        'tollRateBBM': [0.92],
                        'tollRateSavings': [0.46]
                    },
                ],
                'southbound': [
                    {
                        'entryPoint': 'Exit 5 - TOLL N.C. 147 at I-40',
                        'exitPoint': [
                            'Exit 3/2 - Hopson Road / Davis Drive',
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 66 - N.C. 55',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 62 - Green Level West Road',
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.46, 1.01, 1.27, 1.82, 2.28, 2.84, 3.53, 3.53, 3.88, 4.05, 4.79, 5.47, 6.12, 6.64, 7.64, 8.24],
                        'tollRateBBM': [0.92, 2.02, 2.54, 3.64, 4.56, 5.68, 7.06, 7.06, 7.76, 8.10, 9.58, 10.94, 12.24, 13.28, 15.28, 16.48],
                        'tollRateSavings': [0.46, 1.01, 1.27, 1.82, 2.28, 2.84, 3.53, 3.53, 3.88, 4.05, 4.79, 5.47, 6.12, 6.64, 7.64, 8.24]
                    }, {
                        'entryPoint': 'Exit 3/2 - Hopson Road / Davis Drive',
                        'exitPoint': [
                            'Exit 69 - Chapel Hill Road / N.C. 54',
                            'Exit 66 - N.C. 55',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 62 - Green Level West Road',
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [1.01, 1.27, 1.82, 2.28, 2.84, 3.53, 3.53, 3.88, 4.05, 4.79, 5.47, 6.12, 6.64, 7.64, 8.24],
                        'tollRateBBM': [2.02, 2.54, 3.64, 4.56, 5.68, 7.06, 7.06, 7.76, 8.10, 9.58, 10.94, 12.24, 13.28, 15.28, 16.48],
                        'tollRateSavings': [1.01, 1.27, 1.82, 2.28, 2.84, 3.53, 3.53, 3.88, 4.05, 4.79, 5.47, 6.12, 6.64, 7.64, 8.24],
                    }, {
                        'entryPoint': 'Exit 69 - Chapel Hill Road / N.C. 54',
                        'exitPoint': [
                            'Exit 66 - N.C. 55',
                            'Exit 64 - Morrisville Parkway',
                            'Exit 62 - Green Level West Road',
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.81, 1.36, 1.82, 2.38, 3.07, 3.07, 3.42, 3.59, 4.33, 5.01, 5.66, 6.18, 7.18, 7.78],
                        'tollRateBBM': [1.62, 2.72, 3.64, 4.76, 6.14, 6.14, 6.84, 7.18, 8.66, 10.02, 11.32, 12.36, 14.36, 15.56],
                        'tollRateSavings': [0.81, 1.36, 1.82, 2.38, 3.07, 3.07, 3.42, 3.59, 4.33, 5.01, 5.66, 6.18, 7.18, 7.78],
                    }, {
                        'entryPoint': 'Exit 66 - N.C. 55',
                        'exitPoint': [
                            'Exit 64 - Morrisville Parkway',
                            'Exit 62 - Green Level West Road',
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.55, 1.01, 1.57, 2.26, 2.26, 2.61, 2.78, 3.52, 4.20, 4.85, 5.37, 6.37, 6.97],
                        'tollRateBBM': [1.10, 2.02, 3.14, 4.52, 4.52, 5.22, 5.56, 7.04, 8.40, 9.70, 10.74, 12.74, 13.94],
                        'tollRateSavings': [0.55, 1.01, 1.57, 2.26, 2.26, 2.61, 2.78, 3.52, 4.20, 4.85, 5.37, 6.37, 6.97],
                    }, {
                        'entryPoint': 'Exit 64 - Morrisville Parkway',
                        'exitPoint': [
                            'Exit 62 - Green Level West Road',
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.46, 1.02, 1.71, 1.71, 2.06, 2.23, 2.97, 3.65, 4.30, 4.82, 5.82, 6.42],
                        'tollRateBBM': [0.92, 2.04, 3.42, 3.42, 4.12, 4.46, 5.94, 7.30, 8.60, 9.64, 11.64, 12.84],
                        'tollRateSavings': [0.46, 1.02, 1.71, 1.71, 2.06, 2.23, 2.97, 3.65, 4.30, 4.82, 5.82, 6.42],
                    }, {
                        'entryPoint': 'Exit 62 - Green Level West Road',
                        'exitPoint': [
                            'Exit 59 - U.S. 64',
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.56, 1.25, 1.25, 1.60, 1.77, 2.51, 3.19, 3.84, 4.36, 5.36, 5.96],
                        'tollRateBBM': [1.12, 2.50, 2.50, 3.20, 3.54, 5.02, 6.38, 7.68, 8.72, 10.72, 11.92],
                        'tollRateSavings': [0.56, 1.25, 1.25, 1.60, 1.77, 2.51, 3.19, 3.84, 4.36, 5.36, 5.96],
                    }, {
                        'entryPoint': 'Exit 59 - U.S. 64',
                        'exitPoint': [
                            'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [1.25, 1.25, 1.60, 1.77, 2.51, 3.19, 3.84, 4.36, 5.36, 5.96],
                        'tollRateBBM': [2.50, 2.50, 3.20, 3.54, 5.02, 6.38, 7.68, 8.72, 10.72, 11.92],
                        'tollRateSavings': [1.25, 1.25, 1.60, 1.77, 2.51, 3.19, 3.84, 4.36, 5.36, 5.96]
                    }, {
                        'entryPoint': 'Exit 57 - Old U.S. Highway 1 / S. Salem Street',
                        'exitPoint': [
                            'Exit 56 - U.S. 1',
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.32, 0.67, 0.84, 1.58, 2.26, 2.91, 3.43, 4.43, 5.03],
                        'tollRateBBM': [0.64, 1.34, 1.68, 3.16, 4.52, 5.82, 6.86, 8.86, 10.06],
                        'tollRateSavings': [0.32, 0.67, 0.84, 1.58, 2.26, 2.91, 3.43, 4.43, 5.03],
                    }, {
                        'entryPoint': 'Exit 56 - U.S. 1',
                        'exitPoint': [
                            'Exit 55 - Veridea Parkway',
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.35, 0.52, 1.26, 1.94, 2.59, 3.11, 4.11, 4.71],
                        'tollRateBBM': [0.70, 1.04, 2.52, 3.88, 5.18, 6.22, 8.22, 9.42],
                        'tollRateSavings': [0.35, 0.52, 1.26, 1.94, 2.59, 3.11, 4.11, 4.71],
                    }, {
                        'entryPoint': 'Exit 55 - Veridea Parkway',
                        'exitPoint': [
                            'Exit 54 - N.C. 55',
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.52, 1.26, 1.94, 2.59, 3.11, 4.11, 4.71],
                        'tollRateBBM': [1.04, 2.52, 3.88, 5.18, 6.22, 8.22, 9.42],
                        'tollRateSavings': [0.52, 1.26, 1.94, 2.59, 3.11, 4.11, 4.71],
                    }, {
                        'entryPoint': 'Exit 54 - N.C. 55',
                        'exitPoint': [
                            'Exit 50 - Holly Springs Rd.',
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.74, 1.42, 2.07, 2.59, 3.59, 4.19],
                        'tollRateBBM': [1.48, 2.84, 4.14, 5.18, 7.18, 8.38],
                        'tollRateSavings': [0.74, 1.42, 2.07, 2.59, 3.59, 4.19],
                    }, {
                        'entryPoint': 'Exit 50 - Holly Springs Rd.',
                        'exitPoint': [
                            'Exit 47 - Bells Lake Rd.',
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.68, 1.33, 1.85, 2.85, 3.45],
                        'tollRateBBM': [1.36, 2.66, 3.70, 5.70, 6.90],
                        'tollRateSavings':[0.68, 1.33, 1.85, 2.85, 3.45],
                    }, {
                        'entryPoint': 'Exit 47 - Bells Lake Rd.',
                        'exitPoint': [
                            'Exit 45 - U.S. 401',
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.65, 1.17, 2.17, 2.77],
                        'tollRateBBM': [1.30, 2.34, 4.34, 5.54],
                        'tollRateSavings': [0.65, 1.17, 2.17, 2.77],
                    }, {
                        'entryPoint': 'Exit 45 - U.S. 401',
                        'exitPoint': [
                            'Exit 43 - Old Stage Rd.',
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [0.52, 1.52, 2.12],
                        'tollRateBBM': [1.04, 3.04, 4.24],
                        'tollRateSavings': [0.52, 1.52, 2.12],
                    }, {
                        'entryPoint': 'Exit 43 - Old Stage Rd.',
                        'exitPoint': [
                            'Exit 39 - N.C. 50',
                            'Exit 36 - I-40'
                        ],
                        'tollRateTA': [1.00, 1.60],
                        'tollRateBBM': [2.00, 3.20],
                        'tollRateSavings': [1.00, 1.60],
                    }, {
                        'entryPoint': 'Exit 36 - I-40',
                        'exitPoint': ['Exit 39 - N.C. 50'],
                        'tollRateTA': [0.60],
                        'tollRateBBM': [1.20],
                        'tollRateSavings': [0.60]
                    }
                ]
            },
        },
        monExpTollJson: {
            'routeDir': {
                'eastbound': [
                    {
                        'entryPoint': 'Exit 255 - U.S. 74 (West)',
                        'exitPoint': 'Exit 257 - Indian Trail-Fairview Road',
                        'tollRateTA': 0.30,
                        'tollRateBBM': 0.60,
                        'tollRateSavings': 0.30,
                        'tollZone': 1,
                    },
                    {
                        'entryPoint': 'Exit 257 - Indian Trail-Fairview Road',
                        'exitPoint': 'Exit 259 - Unionville-Indian Trail Road',
                        'tollRateTA': 0.36,
                        'tollRateBBM': 0.72,
                        'tollRateSavings': 0.36,
                        'tollZone': 3,
                    },
                    {
                        'entryPoint': 'Exit 259 - Unionville-Indian Trail Road',
                        'exitPoint': 'Exit 260 - N. Rocky River Road',
                        'tollRateTA': 0.22,
                        'tollRateBBM': 0.44,
                        'tollRateSavings': 0.22,
                        'tollZone': 5,
                    },
                    {
                        'entryPoint': 'Exit 260 - N. Rocky River Road',
                        'exitPoint': 'Exit 264 - U.S. 601',
                        'tollRateTA': 0.63,
                        'tollRateBBM': 1.26,
                        'tollRateSavings': 0.63,
                        'tollZone': 7,
                    },
                    {
                        'entryPoint': 'Exit 264 - U.S. 601',
                        'exitPoint': 'Exit 266 - Morgan Mill Road',
                        'tollRateTA': 0.29,
                        'tollRateBBM': 0.58,
                        'tollRateSavings': 0.29,
                        'tollZone': 9,
                    },
                    {
                        'entryPoint': 'Exit 266 - Morgan Mill Road',
                        'exitPoint': 'Exit 270 - Austin Chaney Road',
                        'tollRateTA': 0.64,
                        'tollRateBBM': 1.28,
                        'tollRateSavings': 0.64,
                        'tollZone': 11,
                    },
                    {
                        'entryPoint': 'Exit 270 - Austin Chaney Road',
                        'exitPoint': 'Exit 273 - U.S. 74 (East)',
                        'tollRateTA': 0.48,
                        'tollRateBBM': 0.96,
                        'tollRateSavings': 0.48,
                        'tollZone': 13,
                    },
                ],
                'westbound': [
                    {
                        'entryPoint': 'Exit 257 - Indian Trail-Fairview Road',
                        'exitPoint': 'Exit 255 - U.S. 74 (West)',
                        'tollRateTA': 0.30,
                        'tollRateBBM': 0.60,
                        'tollRateSavings': 0.30,
                        'tollZone': 2,
                    },
                    {
                        'entryPoint': 'Exit 259 - Unionville-Indian Trail Road',
                        'exitPoint': 'Exit 257 - Indian Trail-Fairview Road',
                        'tollRateTA': 0.36,
                        'tollRateBBM': 0.72,
                        'tollRateSavings': 0.36,
                        'tollZone': 4,
                    },
                    {
                        'entryPoint': 'Exit 260 - N. Rocky River Road',
                        'exitPoint': 'Exit 259 - Unionville-Indian Trail Road',
                        'tollRateTA': 0.22,
                        'tollRateBBM': 0.44,
                        'tollRateSavings': 0.22,
                        'tollZone': 6,
                    },
                    {
                        'entryPoint': 'Exit 264 - U.S. 601',
                        'exitPoint': 'Exit 260 - N. Rocky River Road',
                        'tollRateTA': 0.63,
                        'tollRateBBM': 1.26,
                        'tollRateSavings': 0.63,
                        'tollZone': 8,
                    },
                    {
                        'entryPoint': 'Exit 266 - Morgan Mill Road',
                        'exitPoint': 'Exit 264 - U.S. 601',
                        'tollRateTA': 0.29,
                        'tollRateBBM': 0.58,
                        'tollRateSavings': 0.29,
                        'tollZone': 10,
                    },
                    {
                        'entryPoint': 'Exit 270 - Austin Chaney Road',
                        'exitPoint': 'Exit 266 - Morgan Mill Road',
                        'tollRateTA': 0.64,
                        'tollRateBBM': 1.28,
                        'tollRateSavings': 0.64,
                        'tollZone': 12,
                    },
                    {
                        'entryPoint': 'Exit 273 - U.S. 74 (East)',
                        'exitPoint': 'Exit 270 - Austin Chaney Road',
                        'tollRateTA': 0.48,
                        'tollRateBBM': 0.96,
                        'tollRateSavings': 0.48,
                        'tollZone': 14,
                    },
                ],
            },
        },
        monExpGeoJson: {
            'type': 'FeatureCollection',
            'features': [{
                    'type': 'Feature',
                    'id': 'monExp',
                    'properties': {
                        'strokeColor': '#95a0ad',
                        'strokeThickness': 5,
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': [
                            [-80.675228, 35.097715],
                            [-80.672821, 35.0949779],
                            [-80.670662, 35.092137],
                            [-80.668862, 35.091137],
                            [-80.667469, 35.090747],
                            [-80.66403, 35.090817],
                            [-80.661718, 35.0918],
                            [-80.658371, 35.093485],
                            [-80.655281, 35.095311],
                            [-80.652277, 35.096786],
                            [-80.649444, 35.097699],
                            [-80.64644, 35.098331],
                            [-80.643865, 35.098542],
                            [-80.638811, 35.09798],
                            [-80.636236, 35.097137],
                            [-80.634005, 35.096295],
                            [-80.63177, 35.095592],
                            [-80.629885, 35.09489],
                            [-80.628683, 35.094539],
                            [-80.62731, 35.093907],
                            [-80.625336, 35.092924],
                            [-80.62404, 35.092011],
                            [-80.622761, 35.091027],
                            [-80.621817, 35.089904],
                            [-80.620615, 35.088359],
                            [-80.618984, 35.08576],
                            [-80.617611, 35.083653],
                            [-80.616581, 35.082318],
                            [-80.615465, 35.080914],
                            [-80.61383, 35.079368],
                            [-80.612032, 35.078034],
                            [-80.610401, 35.076559],
                            [-80.60868, 35.075294],
                            [-80.60663, 35.073482],
                            [-80.603712, 35.071093],
                            [-80.6013, 35.069056],
                            [-80.599592, 35.067651],
                            [-80.597103, 35.065614],
                            [-80.595386, 35.06463],
                            [-80.592983, 35.063225],
                            [-80.590494, 35.061961],
                            [-80.587833, 35.060485],
                            [-80.5848, 35.058799],
                            [-80.582941, 35.057745],
                            [-80.58079, 35.05641],
                            [-80.579164, 35.055075],
                            [-80.577362, 35.05353],
                            [-80.575044, 35.051422],
                            [-80.573156, 35.049735],
                            [-80.571182, 35.047979],
                            [-80.56884, 35.045761],
                            [-80.567381, 35.044496],
                            [-80.565235, 35.042528],
                            [-80.56309, 35.040631],
                            [-80.561116, 35.038733],
                            [-80.559313, 35.037258],
                            [-80.557425, 35.035922],
                            [-80.556137, 35.03522],
                            [-80.554678, 35.034587],
                            [-80.551588, 35.033884],
                            [-80.548928, 35.033252],
                            [-80.547039, 35.032549],
                            [-80.545409, 35.031776],
                            [-80.544538, 35.031264],
                            [-80.542907, 35.03028],
                            [-80.54136, 35.028944],
                            [-80.539646, 35.02775],
                            [-80.536672, 35.025571],
                            [-80.533239, 35.023251],
                            [-80.531179, 35.021775],
                            [-80.528089, 35.019456],
                            [-80.5256, 35.017558],
                            [-80.523111, 35.015871],
                            [-80.521051, 35.014324],
                            [-80.518734, 35.012778],
                            [-80.517103, 35.011934],
                            [-80.516245, 35.011512],
                            [-80.513841, 35.010458],
                            [-80.510666, 35.009544],
                            [-80.507318, 35.00863],
                            [-80.502168, 35.007154],
                            [-80.49616, 35.005537],
                            [-80.489895, 35.003849],
                            [-80.484144, 35.002303],
                            [-80.478307, 35.000615],
                            [-80.474102, 34.99949],
                            [-80.471012, 34.998576],
                            [-80.46878, 34.998154],
                            [-80.466377, 34.998014],
                            [-80.44895, 34.997662],
                            [-80.445666, 34.997592],
                            [-80.44, 34.997451],
                            [-80.435023, 34.997381],
                            [-80.430646, 34.997311],
                            [-80.427641, 34.9971702],
                            [-80.42498, 34.996819],
                            [-80.4224, 34.996115],
                            [-80.420003, 34.995201],
                            [-80.4182, 34.994147],
                            [-80.41614, 34.992811],
                            [-80.41433, 34.991053],
                            [-80.412278, 34.988803],
                            [-80.410733, 34.986904],
                            [-80.409789, 34.985779],
                            [-80.408673, 34.984935],
                            [-80.407557, 34.984513],
                            [-80.406012, 34.984302],
                            [-80.40421, 34.984232],
                            [-80.402, 34.984322],
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit255',
                        'exitName': 'Exit 255 - U.S. 74 (West)',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.67526817321777,
                            35.097755819266084,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit257',
                        'exitName': 'Exit 257 - Indian Trail-Fairview Road',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.63866138458252,
                            35.09793137979344,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit259',
                        'exitName': 'Exit 259 - Unionville-Indian Trail Road',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.61055183410645,
                            35.07668581167165,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit260',
                        'exitName': 'Exit 260 - N. Rocky River Road',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.59239864349365,
                            35.06295226109525,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit264',
                        'exitName': 'Exit 264 - U.S. 601',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.53974151611327,
                            35.02781757937468,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit266',
                        'exitName': 'Exit 266 - Morgan Mill Road',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.51605224609375,
                            35.01147480593768,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit270',
                        'exitName': 'Exit 270 - Austin Chaney Road',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.44863224029541,
                            34.99758966933717,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'exitId': 'exit273',
                        'exitName': 'Exit 273 - U.S. 74 (East)',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.40185451507568,
                            34.984264753534525,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'title': 'NC Quick Pass Customer Service Center',
                        //"subTitle": "Customer Service Center",
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.579750061035156,
                            35.024055480957031,
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'zoneId': 'gantryZones',
                        'routeName': 'Monroe Expressway',
                    },
                    'geometry': {
                        'type': 'MultiPoint',
                        'coordinates': [
                            [-80.41297, 34.9895755],
                            [-80.488051, 35.003288],
                            [-80.528039, 35.019373],
                            [-80.57066, 35.047452],
                            [-80.601672, 35.069347],
                            [-80.619517, 35.086518],
                            [-80.660154, 35.092676],
                        ],
                    },
                },
            ],
        },
        i77ExpGeoJson: {
            'type': 'FeatureCollection',
            'features': [{
                    'type': 'Feature',
                    'properties': {
                        'strokeColor': '#95a0ad',
                        'strokeThickness': 5,
                        'routeName': 'I-77 Express HOV Lanes',
                    },
                    'geometry': {
                        'type': 'LineString',
                        'coordinates': [
                            [-80.85892, 35.60586],
                            [-80.85914, 35.60464],
                            [-80.85918, 35.60439],
                            [-80.85962, 35.60196],
                            [-80.85973, 35.60133],
                            [-80.85988, 35.60053],
                            [-80.85991, 35.60032],
                            [-80.85993, 35.60019],
                            [-80.86003, 35.59965],
                            [-80.86008, 35.59934],
                            [-80.86011, 35.59915],
                            [-80.86014, 35.59891],
                            [-80.8602, 35.59843],
                            [-80.86024, 35.59791],
                            [-80.86026, 35.59768],
                            [-80.86028, 35.59713],
                            [-80.86029, 35.59669],
                            [-80.86028, 35.59628],
                            [-80.86026, 35.59592],
                            [-80.86023, 35.59537],
                            [-80.86015, 35.59459],
                            [-80.86013, 35.59442],
                            [-80.86012, 35.59431],
                            [-80.86008, 35.59412],
                            [-80.86006, 35.59398],
                            [-80.86006, 35.59396],
                            [-80.86, 35.59357],
                            [-80.85992, 35.5932],
                            [-80.85973, 35.59239],
                            [-80.85965, 35.59207],
                            [-80.85957, 35.59175],
                            [-80.85941, 35.59118],
                            [-80.85926, 35.59058],
                            [-80.85899, 35.58958],
                            [-80.85874, 35.58863],
                            [-80.85838, 35.58722],
                            [-80.85808, 35.58622],
                            [-80.8579, 35.58552],
                            [-80.85771, 35.58475],
                            [-80.85695, 35.58193],
                            [-80.85653, 35.58032],
                            [-80.85645, 35.58002],
                            [-80.8564, 35.57983],
                            [-80.85636, 35.57971],
                            [-80.8561, 35.57858],
                            [-80.85598, 35.57792],
                            [-80.85593, 35.57746],
                            [-80.85589, 35.57703],
                            [-80.85586, 35.5764],
                            [-80.85585, 35.57598],
                            [-80.85585, 35.57578],
                            [-80.85587, 35.57544],
                            [-80.85588, 35.57529],
                            [-80.8559, 35.57494],
                            [-80.85593, 35.57468],
                            [-80.856, 35.57411],
                            [-80.85603, 35.57394],
                            [-80.8561, 35.57354],
                            [-80.85615, 35.57334],
                            [-80.85617, 35.57323],
                            [-80.85622, 35.573],
                            [-80.85631, 35.57268],
                            [-80.85654, 35.57182],
                            [-80.85763, 35.56792],
                            [-80.8578, 35.56731],
                            [-80.85841, 35.56508],
                            [-80.85849, 35.56478],
                            [-80.85853, 35.56458],
                            [-80.8586, 35.56425],
                            [-80.85864, 35.564],
                            [-80.85869, 35.56375],
                            [-80.85871, 35.56358],
                            [-80.85873, 35.56339],
                            [-80.85876, 35.5631],
                            [-80.85879, 35.56285],
                            [-80.85881, 35.56257],
                            [-80.85882, 35.5624],
                            [-80.85882, 35.56223],
                            [-80.85883, 35.56201],
                            [-80.85883, 35.56173],
                            [-80.85883, 35.56156],
                            [-80.85882, 35.56134],
                            [-80.8588, 35.56086],
                            [-80.85871, 35.56005],
                            [-80.85859, 35.55921],
                            [-80.85851, 35.55858],
                            [-80.85843, 35.55801],
                            [-80.85824, 35.55669],
                            [-80.85812, 35.55585],
                            [-80.85801, 35.55501],
                            [-80.85797, 35.55462],
                            [-80.85792, 35.55357],
                            [-80.85792, 35.55344],
                            [-80.85791, 35.55289],
                            [-80.85794, 35.55219],
                            [-80.858, 35.5514],
                            [-80.85804, 35.55101],
                            [-80.85806, 35.55084],
                            [-80.85808, 35.55072],
                            [-80.85823, 35.5499],
                            [-80.85842, 35.54893],
                            [-80.85855, 35.54836],
                            [-80.85869, 35.54765],
                            [-80.85891, 35.54669],
                            [-80.8593, 35.54492],
                            [-80.85959, 35.5436],
                            [-80.85996, 35.54193],
                            [-80.86, 35.54171],
                            [-80.86069, 35.53861],
                            [-80.86142, 35.53531],
                            [-80.86157, 35.5346],
                            [-80.86173, 35.53385],
                            [-80.86179, 35.53357],
                            [-80.86217, 35.53185],
                            [-80.86254, 35.53015],
                            [-80.86292, 35.52841],
                            [-80.86306, 35.52781],
                            [-80.86319, 35.52717],
                            [-80.86334, 35.52654],
                            [-80.86393, 35.52386],
                            [-80.86408, 35.52319],
                            [-80.86435, 35.52193],
                            [-80.86483, 35.51974],
                            [-80.86512, 35.51844],
                            [-80.86519, 35.51812],
                            [-80.86527, 35.5177],
                            [-80.86532, 35.51741],
                            [-80.86536, 35.51715],
                            [-80.86546, 35.51651],
                            [-80.86552, 35.51605],
                            [-80.86558, 35.5155],
                            [-80.86561, 35.51519],
                            [-80.86568, 35.51431],
                            [-80.86576, 35.51322],
                            [-80.8658, 35.51268],
                            [-80.86584, 35.51213],
                            [-80.86588, 35.5117],
                            [-80.86597, 35.51054],
                            [-80.86604, 35.50945],
                            [-80.86609, 35.50892],
                            [-80.86613, 35.50839],
                            [-80.86615, 35.5081],
                            [-80.86621, 35.50733],
                            [-80.86624, 35.507],
                            [-80.8663, 35.5062],
                            [-80.86635, 35.50551],
                            [-80.86643, 35.50433],
                            [-80.86645, 35.50414],
                            [-80.86646, 35.50398],
                            [-80.86649, 35.50376],
                            [-80.86652, 35.50349],
                            [-80.86661, 35.50305],
                            [-80.86667, 35.50281],
                            [-80.86674, 35.50258],
                            [-80.86681, 35.50237],
                            [-80.86688, 35.50218],
                            [-80.86692, 35.50207],
                            [-80.86697, 35.50196],
                            [-80.8671, 35.50167],
                            [-80.86732, 35.50122],
                            [-80.86786, 35.50015],
                            [-80.86826, 35.49934],
                            [-80.86906, 35.49773],
                            [-80.86978, 35.49628],
                            [-80.87087, 35.49409],
                            [-80.87153, 35.49275],
                            [-80.87184, 35.49214],
                            [-80.87231, 35.49118],
                            [-80.87305, 35.48969],
                            [-80.87345, 35.48889],
                            [-80.87374, 35.4883],
                            [-80.87431, 35.48715],
                            [-80.87447, 35.48679],
                            [-80.87453, 35.48662],
                            [-80.87462, 35.48639],
                            [-80.87468, 35.48617],
                            [-80.87476, 35.4859],
                            [-80.8748, 35.48571],
                            [-80.87484, 35.48553],
                            [-80.87488, 35.48533],
                            [-80.87489, 35.48522],
                            [-80.87491, 35.4851],
                            [-80.87493, 35.48489],
                            [-80.87494, 35.48465],
                            [-80.87495, 35.48436],
                            [-80.87496, 35.48425],
                            [-80.87496, 35.48349],
                            [-80.87496, 35.4828],
                            [-80.87497, 35.48234],
                            [-80.87497, 35.48116],
                            [-80.87497, 35.48053],
                            [-80.87498, 35.47962],
                            [-80.87498, 35.47931],
                            [-80.87498, 35.47809],
                            [-80.87499, 35.47764],
                            [-80.875, 35.47653],
                            [-80.87503, 35.47514],
                            [-80.87511, 35.4737],
                            [-80.87515, 35.4731],
                            [-80.8752, 35.47249],
                            [-80.87522, 35.47216],
                            [-80.8753, 35.47128],
                            [-80.87536, 35.47071],
                            [-80.8754, 35.47029],
                            [-80.87548, 35.46964],
                            [-80.87574, 35.46731],
                            [-80.87578, 35.46691],
                            [-80.87584, 35.4664],
                            [-80.87589, 35.46596],
                            [-80.87592, 35.46564],
                            [-80.87593, 35.4654],
                            [-80.87594, 35.46517],
                            [-80.87595, 35.46496],
                            [-80.87595, 35.46471],
                            [-80.87595, 35.46447],
                            [-80.87594, 35.46425],
                            [-80.87594, 35.46416],
                            [-80.87593, 35.46402],
                            [-80.87592, 35.46385],
                            [-80.8759, 35.46366],
                            [-80.87589, 35.46341],
                            [-80.87586, 35.46319],
                            [-80.87585, 35.46307],
                            [-80.87582, 35.46286],
                            [-80.87577, 35.46256],
                            [-80.87576, 35.46252],
                            [-80.87574, 35.46238],
                            [-80.87568, 35.46206],
                            [-80.87563, 35.46185],
                            [-80.87559, 35.46165],
                            [-80.87556, 35.46155],
                            [-80.8755, 35.46134],
                            [-80.87547, 35.4612],
                            [-80.87544, 35.46109],
                            [-80.87538, 35.46091],
                            [-80.87535, 35.46082],
                            [-80.87525, 35.46049],
                            [-80.87517, 35.46026],
                            [-80.87506, 35.45998],
                            [-80.87495, 35.4597],
                            [-80.87485, 35.45946],
                            [-80.87471, 35.45914],
                            [-80.87461, 35.45895],
                            [-80.87454, 35.45879],
                            [-80.87445, 35.45863],
                            [-80.87437, 35.45847],
                            [-80.87421, 35.45817],
                            [-80.87386, 35.45753],
                            [-80.87291, 35.45583],
                            [-80.87278, 35.4556],
                            [-80.87257, 35.45521],
                            [-80.87236, 35.4548],
                            [-80.87222, 35.45452],
                            [-80.87201, 35.45408],
                            [-80.87194, 35.45395],
                            [-80.87181, 35.45366],
                            [-80.87171, 35.45344],
                            [-80.87165, 35.4533],
                            [-80.87159, 35.45316],
                            [-80.87153, 35.45303],
                            [-80.87148, 35.4529],
                            [-80.87142, 35.45276],
                            [-80.87134, 35.45256],
                            [-80.87119, 35.45217],
                            [-80.87113, 35.45201],
                            [-80.87105, 35.4518],
                            [-80.87088, 35.4513],
                            [-80.87081, 35.4511],
                            [-80.87074, 35.45091],
                            [-80.87067, 35.45067],
                            [-80.87058, 35.45039],
                            [-80.87045, 35.44996],
                            [-80.87034, 35.44956],
                            [-80.87024, 35.44919],
                            [-80.87019, 35.44899],
                            [-80.87004, 35.44836],
                            [-80.86997, 35.44802],
                            [-80.86988, 35.4476],
                            [-80.86984, 35.44738],
                            [-80.86982, 35.44729],
                            [-80.86974, 35.44678],
                            [-80.86973, 35.44678],
                            [-80.86971, 35.44663],
                            [-80.86968, 35.44642],
                            [-80.86965, 35.44628],
                            [-80.86962, 35.44608],
                            [-80.86959, 35.44584],
                            [-80.86954, 35.44539],
                            [-80.86951, 35.44504],
                            [-80.86947, 35.44461],
                            [-80.86944, 35.44403],
                            [-80.86942, 35.44363],
                            [-80.8694, 35.44306],
                            [-80.8694, 35.44281],
                            [-80.8694, 35.44259],
                            [-80.8694, 35.44253],
                            [-80.8694, 35.44241],
                            [-80.8694, 35.4423],
                            [-80.8694, 35.44215],
                            [-80.86942, 35.4417],
                            [-80.86944, 35.44107],
                            [-80.86948, 35.43998],
                            [-80.86949, 35.43972],
                            [-80.8695, 35.43949],
                            [-80.86952, 35.43912],
                            [-80.86952, 35.43893],
                            [-80.86953, 35.43853],
                            [-80.86954, 35.43817],
                            [-80.86954, 35.43792],
                            [-80.86953, 35.43752],
                            [-80.8695, 35.43705],
                            [-80.86947, 35.43666],
                            [-80.86944, 35.43631],
                            [-80.86941, 35.43606],
                            [-80.86941, 35.43602],
                            [-80.86938, 35.43579],
                            [-80.86929, 35.43521],
                            [-80.86925, 35.435],
                            [-80.8692, 35.43472],
                            [-80.86919, 35.4347],
                            [-80.86912, 35.43436],
                            [-80.86906, 35.43413],
                            [-80.86898, 35.4338],
                            [-80.86889, 35.43347],
                            [-80.86883, 35.43326],
                            [-80.86874, 35.43295],
                            [-80.8686, 35.43252],
                            [-80.86849, 35.4322],
                            [-80.86837, 35.43188],
                            [-80.86825, 35.43158],
                            [-80.86812, 35.43126],
                            [-80.86789, 35.43074],
                            [-80.86774, 35.43044],
                            [-80.86759, 35.43013],
                            [-80.86749, 35.42993],
                            [-80.86738, 35.42972],
                            [-80.86722, 35.42942],
                            [-80.86693, 35.42892],
                            [-80.86659, 35.42833],
                            [-80.86538, 35.42629],
                            [-80.86318, 35.42255],
                            [-80.86275, 35.42182],
                            [-80.86241, 35.42123],
                            [-80.86211, 35.42073],
                            [-80.862, 35.42054],
                            [-80.86187, 35.42033],
                            [-80.86176, 35.42013],
                            [-80.86159, 35.41984],
                            [-80.86147, 35.41964],
                            [-80.86135, 35.41944],
                            [-80.86118, 35.41915],
                            [-80.86107, 35.41895],
                            [-80.8609, 35.41865],
                            [-80.86073, 35.41837],
                            [-80.86062, 35.41816],
                            [-80.86047, 35.41791],
                            [-80.8603, 35.41757],
                            [-80.86015, 35.41727],
                            [-80.86, 35.41695],
                            [-80.85986, 35.41664],
                            [-80.85977, 35.41642],
                            [-80.85964, 35.41611],
                            [-80.85944, 35.41559],
                            [-80.85926, 35.41507],
                            [-80.85909, 35.41454],
                            [-80.85884, 35.41362],
                            [-80.85873, 35.41311],
                            [-80.85844, 35.4114],
                            [-80.85814, 35.40959],
                            [-80.85804, 35.40904],
                            [-80.85795, 35.40844],
                            [-80.85782, 35.40764],
                            [-80.85774, 35.40716],
                            [-80.8576, 35.40631],
                            [-80.85752, 35.40581],
                            [-80.85734, 35.40475],
                            [-80.8571, 35.40328],
                            [-80.85695, 35.40239],
                            [-80.85695, 35.40238],
                            [-80.85687, 35.40193],
                            [-80.85679, 35.40149],
                            [-80.85672, 35.40116],
                            [-80.85664, 35.40084],
                            [-80.85653, 35.40043],
                            [-80.85644, 35.4001],
                            [-80.85627, 35.39956],
                            [-80.85612, 35.39911],
                            [-80.85588, 35.39849],
                            [-80.85571, 35.39808],
                            [-80.85563, 35.39788],
                            [-80.85535, 35.39728],
                            [-80.8551, 35.39678],
                            [-80.85483, 35.39628],
                            [-80.85454, 35.39578],
                            [-80.85428, 35.39535],
                            [-80.85421, 35.39524],
                            [-80.85362, 35.39432],
                            [-80.85318, 35.39362],
                            [-80.85275, 35.39295],
                            [-80.85242, 35.39243],
                            [-80.85218, 35.39204],
                            [-80.85206, 35.39185],
                            [-80.85196, 35.39168],
                            [-80.85173, 35.39126],
                            [-80.85158, 35.39096],
                            [-80.85143, 35.39066],
                            [-80.85129, 35.39037],
                            [-80.8512, 35.39015],
                            [-80.85112, 35.38995],
                            [-80.85104, 35.38975],
                            [-80.85093, 35.38945],
                            [-80.85085, 35.38922],
                            [-80.85078, 35.38902],
                            [-80.85065, 35.3886],
                            [-80.85062, 35.3885],
                            [-80.85051, 35.38808],
                            [-80.85044, 35.38776],
                            [-80.85039, 35.38754],
                            [-80.85032, 35.38711],
                            [-80.85025, 35.38669],
                            [-80.85023, 35.38658],
                            [-80.8502, 35.38626],
                            [-80.85018, 35.38604],
                            [-80.85016, 35.38583],
                            [-80.85014, 35.3854],
                            [-80.85012, 35.38507],
                            [-80.85011, 35.38464],
                            [-80.8501, 35.38438],
                            [-80.85008, 35.38382],
                            [-80.85007, 35.38355],
                            [-80.85006, 35.38335],
                            [-80.85002, 35.38291],
                            [-80.84999, 35.38266],
                            [-80.84998, 35.38253],
                            [-80.84994, 35.38226],
                            [-80.84989, 35.38191],
                            [-80.84985, 35.38169],
                            [-80.84979, 35.38147],
                            [-80.84974, 35.38128],
                            [-80.84971, 35.38116],
                            [-80.8495, 35.38044],
                            [-80.84939, 35.38009],
                            [-80.84928, 35.37977],
                            [-80.84907, 35.37922],
                            [-80.84889, 35.3788],
                            [-80.84878, 35.37856],
                            [-80.84853, 35.37803],
                            [-80.84845, 35.37789],
                            [-80.84806, 35.37718],
                            [-80.84784, 35.37681],
                            [-80.84741, 35.37609],
                            [-80.84704, 35.37548],
                            [-80.84546, 35.37283],
                            [-80.84512, 35.37227],
                            [-80.84484, 35.37179],
                            [-80.84454, 35.37129],
                            [-80.84435, 35.37097],
                            [-80.84409, 35.37048],
                            [-80.84388, 35.37007],
                            [-80.84365, 35.36957],
                            [-80.84348, 35.36914],
                            [-80.84331, 35.36871],
                            [-80.84311, 35.36809],
                            [-80.84307, 35.36797],
                            [-80.84304, 35.36784],
                            [-80.84298, 35.36764],
                            [-80.84288, 35.36726],
                            [-80.8428, 35.3669],
                            [-80.84267, 35.36619],
                            [-80.84263, 35.36585],
                            [-80.84259, 35.36541],
                            [-80.84253, 35.36483],
                            [-80.84254, 35.36404],
                            [-80.84254, 35.36395],
                            [-80.84255, 35.36381],
                            [-80.84255, 35.36379],
                            [-80.84256, 35.3636],
                            [-80.84256, 35.36357],
                            [-80.84257, 35.36355],
                            [-80.84258, 35.36333],
                            [-80.84261, 35.36289],
                            [-80.84264, 35.36269],
                            [-80.84267, 35.36245],
                            [-80.84276, 35.36189],
                            [-80.84293, 35.36114],
                            [-80.84301, 35.36082],
                            [-80.84304, 35.36067],
                            [-80.84317, 35.36028],
                            [-80.84335, 35.35976],
                            [-80.84347, 35.35945],
                            [-80.84377, 35.35874],
                            [-80.84506, 35.35593],
                            [-80.8458, 35.3543],
                            [-80.84597, 35.3539],
                            [-80.8462, 35.35338],
                            [-80.84641, 35.35285],
                            [-80.84663, 35.3523],
                            [-80.84702, 35.35119],
                            [-80.84719, 35.3507],
                            [-80.84726, 35.35049],
                            [-80.84743, 35.34993],
                            [-80.84763, 35.34919],
                            [-80.84783, 35.34856],
                            [-80.84783, 35.34855],
                            [-80.84785, 35.34846],
                            [-80.84786, 35.34844],
                            [-80.84787, 35.34837],
                            [-80.84793, 35.34815],
                            [-80.84808, 35.34741],
                            [-80.8482, 35.34685],
                            [-80.8485, 35.34515],
                            [-80.8487, 35.34397],
                            [-80.84875, 35.34347],
                            [-80.8488, 35.34311],
                            [-80.84884, 35.34271],
                            [-80.84887, 35.34228],
                            [-80.84888, 35.34217],
                            [-80.84892, 35.34121],
                            [-80.84894, 35.34055],
                            [-80.84895, 35.33972],
                            [-80.84894, 35.33915],
                            [-80.84894, 35.33862],
                            [-80.84893, 35.33842],
                            [-80.84891, 35.33801],
                            [-80.84888, 35.33744],
                            [-80.84887, 35.33698],
                            [-80.84884, 35.33646],
                            [-80.84882, 35.33612],
                            [-80.8488, 35.33578],
                            [-80.84875, 35.33503],
                            [-80.84872, 35.33463],
                            [-80.84869, 35.33385],
                            [-80.84869, 35.33384],
                            [-80.84867, 35.33346],
                            [-80.84856, 35.33148],
                            [-80.84854, 35.33105],
                            [-80.84847, 35.32976],
                            [-80.84839, 35.3287],
                            [-80.84817, 35.32486],
                            [-80.84814, 35.32451],
                            [-80.84809, 35.32355],
                            [-80.84802, 35.32245],
                            [-80.84794, 35.32115],
                            [-80.84771, 35.31712],
                            [-80.84767, 35.31645],
                            [-80.84764, 35.31582],
                            [-80.8476, 35.3152],
                            [-80.84758, 35.31476],
                            [-80.84757, 35.31434],
                            [-80.84757, 35.3139],
                            [-80.84758, 35.31317],
                            [-80.8476, 35.31282],
                            [-80.84761, 35.31258],
                            [-80.84764, 35.31201],
                            [-80.84767, 35.31172],
                            [-80.84776, 35.3108],
                            [-80.84786, 35.31002],
                            [-80.84796, 35.3094],
                            [-80.84809, 35.30875],
                            [-80.84811, 35.30861],
                            [-80.84834, 35.30764],
                            [-80.8484, 35.3074],
                            [-80.84843, 35.30727],
                            [-80.84843, 35.30726],
                            [-80.84855, 35.30672],
                            [-80.84913, 35.30418],
                            [-80.84946, 35.30291],
                            [-80.84967, 35.30202],
                            [-80.85002, 35.30046],
                            [-80.85019, 35.29971],
                            [-80.85028, 35.29925],
                            [-80.85036, 35.29887],
                            [-80.851, 35.29612],
                            [-80.85117, 35.29536],
                            [-80.85126, 35.29486],
                            [-80.85131, 35.29446],
                            [-80.85136, 35.29406],
                            [-80.85139, 35.29361],
                            [-80.8514, 35.29351],
                            [-80.85142, 35.29302],
                            [-80.85143, 35.2925],
                            [-80.85142, 35.29216],
                            [-80.85141, 35.29199],
                            [-80.85137, 35.29153],
                            [-80.85134, 35.29128],
                            [-80.85129, 35.29087],
                            [-80.85125, 35.29058],
                            [-80.85117, 35.29015],
                            [-80.8511, 35.28986],
                            [-80.85092, 35.28913],
                            [-80.85082, 35.28882],
                            [-80.85072, 35.2885],
                            [-80.85056, 35.28803],
                            [-80.85042, 35.28769],
                            [-80.85011, 35.28699],
                            [-80.84936, 35.28531],
                            [-80.84912, 35.28476],
                            [-80.84887, 35.28418],
                            [-80.8488, 35.28402],
                            [-80.84867, 35.28373],
                            [-80.84771, 35.28159],
                            [-80.84698, 35.27992],
                            [-80.84679, 35.27949],
                            [-80.84658, 35.27905],
                            [-80.8461, 35.27794],
                            [-80.84605, 35.27785],
                            [-80.84551, 35.27662],
                            [-80.8455, 35.2766],
                            [-80.84549, 35.27658],
                            [-80.84544, 35.27646],
                            [-80.84529, 35.27615],
                            [-80.84512, 35.27575],
                            [-80.84497, 35.27535],
                            [-80.84487, 35.27505],
                            [-80.84478, 35.2747],
                            [-80.8447, 35.27424],
                            [-80.84467, 35.27391],
                            [-80.84466, 35.27367],
                            [-80.84466, 35.2735],
                            [-80.84468, 35.27335],
                            [-80.84469, 35.27313],
                            [-80.84471, 35.27294],
                            [-80.84471, 35.27289],
                            [-80.84477, 35.27258],
                            [-80.84479, 35.27242],
                            [-80.84482, 35.27228],
                            [-80.8449, 35.27198],
                            [-80.84497, 35.27176],
                            [-80.84511, 35.27133],
                            [-80.84517, 35.27112],
                            [-80.84522, 35.27098],
                            [-80.8453, 35.27064],
                            [-80.8454, 35.27028],
                            [-80.84545, 35.27002],
                            [-80.84548, 35.26983],
                            [-80.84549, 35.26966],
                            [-80.8455, 35.26943],
                            [-80.84549, 35.26915],
                            [-80.84548, 35.26892],
                            [-80.84546, 35.26879],
                            [-80.84546, 35.26874],
                            [-80.84543, 35.26852],
                            [-80.84543, 35.2685],
                            [-80.8454, 35.26835],
                            [-80.84537, 35.26825],
                            [-80.84533, 35.26807],
                            [-80.84529, 35.26792],
                            [-80.84525, 35.26779],
                            [-80.84518, 35.2676],
                            [-80.84508, 35.26734],
                            [-80.84495, 35.2671],
                            [-80.84487, 35.26693],
                            [-80.84462, 35.26653],
                            [-80.84456, 35.26641],
                            [-80.84443, 35.26624],
                            [-80.84422, 35.26598],
                            [-80.8442, 35.26595],
                            [-80.84386, 35.26553],
                            [-80.84336, 35.26491],
                            [-80.84325, 35.26479],
                            [-80.84319, 35.26471],
                            [-80.84312, 35.26465],
                            [-80.84286, 35.26433],
                            [-80.8422, 35.26351],
                            [-80.84214, 35.26344],
                            [-80.84193, 35.26318],
                            [-80.84166, 35.26283],
                            [-80.84152, 35.2626],
                            [-80.84145, 35.26248],
                            [-80.84139, 35.26236],
                            [-80.84129, 35.26214],
                            [-80.84116, 35.26184],
                            [-80.84111, 35.26169],
                            [-80.84104, 35.26148],
                            [-80.84096, 35.26118],
                            [-80.84093, 35.26103],
                            [-80.84092, 35.26095],
                            [-80.8409, 35.26089],
                            [-80.84088, 35.26069],
                            [-80.84087, 35.26057],
                            [-80.84086, 35.26033],
                            [-80.84086, 35.26016],
                            [-80.84087, 35.26003],
                            [-80.8409, 35.25981],
                            [-80.84092, 35.25966],
                            [-80.84096, 35.2594],
                            [-80.841, 35.25923],
                            [-80.84102, 35.25915],
                            [-80.84105, 35.25907],
                            [-80.8411, 35.25887],
                            [-80.84117, 35.25867],
                            [-80.84133, 35.25831],
                            [-80.84151, 35.2579],
                            [-80.84198, 35.25685],
                            [-80.84317, 35.2542],
                            [-80.84343, 35.25364],
                            [-80.84356, 35.25337],
                            [-80.84423, 35.25182],
                            [-80.84436, 35.25153],
                            [-80.84474, 35.25069],
                            [-80.84476, 35.25068],
                            [-80.84477, 35.25068],
                            [-80.84478, 35.25068],
                            [-80.84479, 35.25068],
                            [-80.8448, 35.25067],
                            [-80.84481, 35.25067],
                            [-80.84482, 35.25067],
                            [-80.84482, 35.25066],
                            [-80.84483, 35.25066],
                            [-80.84488, 35.25059],
                            [-80.84515, 35.25005],
                            [-80.84565, 35.24903],
                            [-80.84608, 35.24819],
                            [-80.84612, 35.2481],
                            [-80.84614, 35.24807],
                            [-80.84614, 35.24806],
                            [-80.84619, 35.24796],
                            [-80.84628, 35.24778],
                            [-80.84644, 35.24749],
                            [-80.8465, 35.2474],
                            [-80.84658, 35.24727],
                            [-80.84663, 35.24721],
                            [-80.84673, 35.24708],
                            [-80.84674, 35.24705],
                            [-80.84675, 35.24703],
                            [-80.84677, 35.247],
                            [-80.84685, 35.24689],
                            [-80.84692, 35.24682],
                            [-80.84712, 35.24662],
                            [-80.84728, 35.24648],
                            [-80.84755, 35.24625],
                            [-80.84788, 35.24597],
                            [-80.84803, 35.24584],
                            [-80.84811, 35.24576],
                            [-80.84818, 35.24568],
                            [-80.84824, 35.24561],
                            [-80.84834, 35.24545],
                            [-80.84838, 35.24534],
                            [-80.84839, 35.24533],
                            [-80.8484, 35.24529],
                            [-80.84842, 35.24521],
                            [-80.84844, 35.24511],
                            [-80.84844, 35.24504],
                            [-80.84844, 35.24498],
                            [-80.84844, 35.24492],
                            [-80.84844, 35.24486],
                            [-80.84843, 35.24479],
                            [-80.84841, 35.24471],
                            [-80.84838, 35.24465],
                            [-80.84833, 35.24453],
                            [-80.84824, 35.24438],
                            [-80.84823, 35.24436],
                            [-80.84822, 35.24434],
                            [-80.84817, 35.2443],
                            [-80.84814, 35.24427],
                            [-80.84809, 35.24424],
                            [-80.84809, 35.24423],
                            [-80.84802, 35.24417],
                            [-80.84801, 35.24416],
                            [-80.84796, 35.24412],
                            [-80.84789, 35.24408],
                            [-80.84783, 35.24405],
                            [-80.84777, 35.24401],
                            [-80.8477, 35.24398],
                            [-80.84764, 35.24394],
                            [-80.84755, 35.2439],
                            [-80.84738, 35.24381],
                            [-80.84719, 35.24371],
                            [-80.84704, 35.24364],
                            [-80.84703, 35.24363],
                            [-80.84687, 35.24355],
                            [-80.84686, 35.24355],
                            [-80.84666, 35.24343],
                            [-80.84656, 35.24338],
                            [-80.84642, 35.2433],
                            [-80.84627, 35.24321],
                            [-80.8461, 35.2431],
                            [-80.84599, 35.24302],
                            [-80.84595, 35.243],
                            [-80.8459, 35.24296],
                            [-80.84587, 35.24294],
                            [-80.84584, 35.24292],
                            [-80.84583, 35.24291],
                            [-80.84581, 35.2429],
                            [-80.8458, 35.24289],
                            [-80.8458, 35.24288],
                            [-80.84579, 35.24287],
                            [-80.84578, 35.24285],
                            [-80.84577, 35.24283],
                            [-80.84567, 35.24277],
                            [-80.8453, 35.24251],
                            [-80.84499, 35.24227],
                            [-80.84498, 35.24227],
                            [-80.84498, 35.24226],
                            [-80.84493, 35.24223],
                            [-80.84479, 35.24212],
                            [-80.8447, 35.24205],
                            [-80.84454, 35.24192],
                            [-80.84436, 35.24177],
                            [-80.8441, 35.24154],
                            [-80.84393, 35.24138],
                            [-80.84351, 35.24096],
                            [-80.84312, 35.24049],
                            [-80.84251, 35.23972],
                            [-80.84228, 35.23945],
                        ],
                    },
                },
                {
                    'type': 'Feature',
                    'properties': {
                        'title': 'NC Quick Pass Customer Service Center',
                        'description': '',
                        //"subTitle": "Customer Service Center",
                        //"text" : "8015 W. W.T. Harris Blvd. Charlotte, NC 28216",
                        'routeName': 'I-77 Express HOV Lanes',
                    },
                    'geometry': {
                        'type': 'Point',
                        'coordinates': [
                            -80.8637367,
                            35.3496054,
                        ],
                    },
                },
            ],
        },
        gis: {
            i77Exp: 'https://gis11.services.ncdot.gov/arcgis/rest/services/NCDOT_RoadNC/RoadNC_RoadData/MapServer/7/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=4326&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson',
            monExp: 'https://gisq11.services.ncdot.gov/arcgis/rest/services/NCDOT_NCRouteArcs/MapServer/7/query?where=RouteID%3D90000900090&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson',
            triExp: 'https://gis11.services.ncdot.gov/arcgis/rest/services/NCDOT_RoadNC/RoadNC_RoadData/MapServer/12/query?where=1%3D1&text=&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&relationParam=&outFields=*&returnGeometry=true&returnTrueCurves=false&maxAllowableOffset=&geometryPrecision=&outSR=4326&returnIdsOnly=false&returnCountOnly=false&orderByFields=&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&gdbVersion=&returnDistinctValues=false&resultOffset=&resultRecordCount=&queryByDistance=&returnExtentsOnly=false&datumTransformation=&parameterValues=&rangeValues=&f=geojson',
        },
    },
    // could I setup prototypal inheritance for getting location?
    // var loc = { getLat: some func that returns coord, getLon: some func that returns coord, etc}
    // include microsofty loc creation func
    // var triLoc = Object.create(loc); triLoc.getLat = new val or func
    location: {
        lat: 35.39173,
        long: -79.60842,
        triExp: {
            lat: 35.82456,
            lon: -78.8939,
        },
        monExp: {
            lat: 35.05991,
            lon: -80.59630,
        },
        i77Exp: {
            lat: 35.41914,
            lon: -80.86075,
        },
    },
    url: {
        rss: 'https://stage-wwwqc.ncquickpass.com/SiteAssets/',
    },
    templates: {
        i77Infobox: String.raw`<div class="custom-infobox">
            <h4>I-77 Express Lanes</h4>
            <p>Please visit <a href="https://www.i77express.com" target="_blank">www.i77express.com</a> for toll rate information.</p>
        </div>`,
        tollPanel: String.raw`<div class="customInfobox">
            <div class="title">
                <a id="resetToll" class="resetLink" href="#">Reset {svg}</a>
                <label>Route</label>
                <h4>{title}</h4>
            </div>
            <form class="inputFields no-widget">
                <div class="inputSelect">
                    <label>Vehicle Class</label>
                    <select id="vehicleClass" name="vehicleClass">
                    <!--loop thru to create options-->
                        <option value="{optionValue}">{optionPlaceholder}</option>
                    </select>
                    <div class="select centered" role="listbox">
                        <span class="value">{optionPlaceholder} {svg}</span>
                        <ul class="optList hidden" role="presentation">
                        <!--loop thru to create list items-->
                        <li class="option" role="option" aria-selected="true">{optionText} {svg}</li>
                        </ul>
                    </div>
            </form>
        </div>`,
    },
    ele: {
        routeName: {
            triExp: 'Triangle Expressway',
            monExp: 'Monroe Expressway',
            i77Exp: 'I-77 Express Lanes',
        },
        mapDiv: document.getElementById('mapholder'),
        mapSelect: document.getElementById('mapPinList'),
        svg: {
            startFlag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 32" width="120px" height="32px"><g transform="translate(-1362.758 -2850)"><path d="M20,38V6H120v4.594l20,11.919L120,33.454V38Z" transform="translate(1342 2844)" style="fill:#00a160"/><text transform="translate(1376 2872)"><tspan x="4px" y="-2px" style="font: bold 14px/14px Arial;fill:#ffffff">Start here</tspan></text></g></svg>',
            endFlag: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 32" width="120px" height="32px"><g transform="translate(-1362.758 -2850)"><path d="M20,38V6H120v4.594l20,11.919L120,33.454V38Z" transform="translate(1342 2844)" style="fill:#d31616"/><text transform="translate(1376 2872)"><tspan x="4px" y="-2px" style="font: bold 14px/14px Arial;fill:#ffffff">End here</tspan></text></g></svg>',
            piggyBank: '<svg xmlns="http://www.w3.org/2000/svg" width="66px" height="60px" viewBox="0 0 66 60"><g transform="translate(-3318 -3364)"><ellipse cx="31.2" cy="7.8" rx="31.2" ry="7.8" transform="translate(3321.6 3408.4)" style="fill:rgba(9,41,64,0.24);"/><circle cx="30" cy="30" r="30" transform="translate(3318 3364)" style="fill:#0079c2;stroke:none;"/><path d="M56.476,43.012h0a30.246,30.246,0,0,0,.562-5.812A30,30,0,0,0,0,24.183,30,30,0,0,1,59.437,30,29.721,29.721,0,0,1,56.476,43.012Z" transform="translate(3318.564 3364)" style="fill:#0091e8;"/><g transform="translate(3318 3364)" style="fill:none;"><path d="M30,0A30,30,0,1,1,0,30,30,30,0,0,1,30,0Z" style="stroke:none;"/><path d="M 30 2 C 26.21913909912109 2 22.55244064331055 2.740039825439453 19.10174942016602 4.199558258056641 C 15.76776885986328 5.609710693359375 12.77312850952148 7.628890991210938 10.20101165771484 10.20101165771484 C 7.628890991210938 12.77312850952148 5.609710693359375 15.76776885986328 4.199558258056641 19.10174942016602 C 2.740039825439453 22.55244064331055 2 26.21913909912109 2 30 C 2 33.78086090087891 2.740039825439453 37.44755935668945 4.199558258056641 40.89825057983398 C 5.609710693359375 44.23223114013672 7.628890991210938 47.22686767578125 10.20101165771484 49.79898834228516 C 12.77312850952148 52.37110900878906 15.76776885986328 54.39028930664062 19.10174942016602 55.80043792724609 C 22.55244064331055 57.25996017456055 26.21913909912109 58 30 58 C 33.78086090087891 58 37.44755935668945 57.25996017456055 40.89825057983398 55.80043792724609 C 44.23223114013672 54.39028930664062 47.22686767578125 52.37110900878906 49.79898834228516 49.79898834228516 C 52.37110900878906 47.22686767578125 54.39028930664062 44.23223114013672 55.80043792724609 40.89825057983398 C 57.25996017456055 37.44755935668945 58 33.78086090087891 58 30 C 58 26.21913909912109 57.25996017456055 22.55244064331055 55.80043792724609 19.10174942016602 C 54.39028930664062 15.76776885986328 52.37110900878906 12.77312850952148 49.79898834228516 10.20101165771484 C 47.22686767578125 7.628890991210938 44.23223114013672 5.609710693359375 40.89825057983398 4.199558258056641 C 37.44755935668945 2.740039825439453 33.78086090087891 2 30 2 M 30 0 C 46.56853866577148 0 60 13.43146133422852 60 30 C 60 46.56853866577148 46.56853866577148 60 30 60 C 13.43146133422852 60 0 46.56853866577148 0 30 C 0 13.43146133422852 13.43146133422852 0 30 0 Z" style="fill:#0079c2;"/></g><path d="M44.834,11.855H40.389A16.241,16.241,0,0,0,35.646,6.52a6.158,6.158,0,0,1,1.482-3.557l.593-.593c.593-.3.593-.889.593-1.482S37.128,0,36.536,0h-.3a6.059,6.059,0,0,0-5.631,4.149,17.388,17.388,0,0,0-6.817-1.186C14.307,2.964,6.6,9.188,6.009,17.19H5.416c-1.778,0-2.075-2.371-2.371-3.853-.3-1.778-2.964-1.778-2.964,0a8.207,8.207,0,0,0,.3,3.853,5.326,5.326,0,0,0,5.335,3.853h.593a15.541,15.541,0,0,0,2.964,5.335h0l.3.3A7.9,7.9,0,0,1,11.936,32.6v2.964c0,1.778,2.075,2.964,4.446,2.964s4.446-1.186,4.446-2.964v-3.26a11.118,11.118,0,0,0,2.964.3,10.082,10.082,0,0,0,2.964-.3v3.26c0,1.778,2.075,2.964,4.446,2.964s4.446-1.186,4.446-2.964V32.6a7.728,7.728,0,0,1,2.075-5.631l.3-.3h0a10.644,10.644,0,0,0,2.075-2.964h4.446c1.778,0,2.964-2.667,2.964-5.928s-1.186-5.928-2.667-5.928Zm-16.6-2.964H19.346a1.588,1.588,0,0,1-1.482-1.482,1.588,1.588,0,0,1,1.482-1.482h8.891a1.4,1.4,0,0,1,1.482,1.482A1.4,1.4,0,0,1,28.237,8.891Zm7.409,8.891a2.8,2.8,0,0,1-2.964-2.964,2.964,2.964,0,0,1,5.928,0A2.8,2.8,0,0,1,35.646,17.783Z" transform="translate(3323.159 3376.456)" style="fill:#0069A8;"/><path d="M44.834,11.855H40.389A16.241,16.241,0,0,0,35.646,6.52a6.158,6.158,0,0,1,1.482-3.557l.593-.593c.593-.3.593-.889.593-1.482S37.128,0,36.536,0h-.3a6.059,6.059,0,0,0-5.631,4.149,17.388,17.388,0,0,0-6.817-1.186C14.307,2.964,6.6,9.188,6.009,17.19H5.416c-1.778,0-2.075-2.371-2.371-3.853-.3-1.778-2.964-1.778-2.964,0a8.207,8.207,0,0,0,.3,3.853,5.326,5.326,0,0,0,5.335,3.853h.593a15.541,15.541,0,0,0,2.964,5.335h0l.3.3A7.9,7.9,0,0,1,11.936,32.6v2.964c0,1.778,2.075,2.964,4.446,2.964s4.446-1.186,4.446-2.964v-3.26a11.118,11.118,0,0,0,2.964.3,10.082,10.082,0,0,0,2.964-.3v3.26c0,1.778,2.075,2.964,4.446,2.964s4.446-1.186,4.446-2.964V32.6a7.728,7.728,0,0,1,2.075-5.631l.3-.3h0a10.644,10.644,0,0,0,2.075-2.964h4.446c1.778,0,2.964-2.667,2.964-5.928s-1.186-5.928-2.667-5.928Zm-16.6-2.964H19.346a1.588,1.588,0,0,1-1.482-1.482,1.588,1.588,0,0,1,1.482-1.482h8.891a1.4,1.4,0,0,1,1.482,1.482A1.4,1.4,0,0,1,28.237,8.891Zm7.409,8.891a2.8,2.8,0,0,1-2.964-2.964,2.964,2.964,0,0,1,5.928,0A2.8,2.8,0,0,1,35.646,17.783Z" transform="translate(3324.159 3374.456)" style="fill:#fff;"/><path d="M21.372,18.609C16.954,16.891,5.336,11.327,17.854,4.7c0,0-16.364,1.391-14.973,14.4h8.264C1.245,8.382,17.69,4.7,17.69,4.7,3.127,9.2,11.309,17.3,13.354,19.1H23.581L21.7,18.691C21.618,18.691,21.454,18.609,21.372,18.609Z" transform="translate(3333.746 3379.399)" style="fill:#00a160;"/></g></svg>',
            resetIcon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24px" height="24px"><path d="M0 0h24v24H0z" fill="none"/><path d="M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z" style="fill:#ffffff"/></svg>',
            vehClass1: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 59.25 15.72" width="59.25" height="15.72"><title>Vehicle Class 1</title><g id="vehClass1" data-name="vehClass1"><path d="M28.2,10.38h-.53V9.44l-.33-.56a2.73,2.73,0,0,0-2.7-2.32h-6.1l-2-3.84A1.39,1.39,0,0,0,15.33,2H2.42a1,1,0,0,0-1,1V5.12H.45A.46.46,0,0,0,0,5.58V10a.45.45,0,0,0,.45.45,2,2,0,0,1,.12.48v.54a.28.28,0,0,0,.28.28H2l1,.44h.54a2.87,2.87,0,0,0,0,.41,3.14,3.14,0,0,0,6.28,0H20.83a3.14,3.14,0,0,0,6.28,0,1.15,1.15,0,0,0,0-.26H28.2a.35.35,0,0,0,.37-.31V10.7A.35.35,0,0,0,28.2,10.38Z" style="fill:#087abf"/><path d="M57.24,9.14c.21-.05.32-.18.35-.5a3.93,3.93,0,0,0-2.9-.23l-.77-1.84.73-.12.86-.12c.58,0,.69-.17.69-.57l-.11-1.1a1.26,1.26,0,0,0-.23-.74A12.83,12.83,0,0,0,51.37,0V.86a7.73,7.73,0,0,1,1.32,1.39l-2.13.92c-.34.17-.4.28-.4.63V4H49a2.78,2.78,0,0,0-2,.46l-1,.69c-.81.58-3.51.58-4.72.18A2.11,2.11,0,0,0,40,5.12a7.53,7.53,0,0,1-3.22-.28A2.05,2.05,0,0,0,35.53,5l-1.26.57c-.41.18-.47.35-.47.87v.8c0,.18.06.24.24.24h.57l-1.32,2.76h.34c.35,0,.41-.06.69-.4l.76.42a3.42,3.42,0,0,0-.64,2,3.47,3.47,0,0,0,3.45,3.46,3.39,3.39,0,0,0,3.34-2.82h6.86c1.43,0,1.61-.06,2.24-1.5l.52-1.32C51.6,8.35,52,7.49,52.57,7A1.78,1.78,0,0,1,53,6.81l.83,2a4,4,0,0,0-1.93,4.28,1.11,1.11,0,0,0,.59-.14,3.4,3.4,0,0,0,3.33,2.79,3.45,3.45,0,0,0,1.44-6.58Zm-18,1.35a2.31,2.31,0,0,1,.75,1l-1.21.06Zm-1.34,4a2.21,2.21,0,0,1-2.24-2.25A2.25,2.25,0,0,1,37.89,10a2.12,2.12,0,0,1,.44.05l-.58,1.36a.84.84,0,0,0-.72.83.86.86,0,0,0,.86.87.75.75,0,0,0,.54-.23H40A2.25,2.25,0,0,1,37.89,14.51Zm8.47-3.34-1.5.06v-.17c-.06-.29-.23-.41-.57-.41H42.9l-.57-1.49h3l1-1.44h1.21Zm9.44,3.34a2.25,2.25,0,0,1-2.25-2.25,2.28,2.28,0,0,1,1-1.81l.59,1.41a1,1,0,0,0-.11.4.84.84,0,1,0,1.67,0,.84.84,0,0,0-.71-.83l-.57-1.37a3,3,0,0,1,.42,0A2.24,2.24,0,0,1,58,12.26,2.21,2.21,0,0,1,55.8,14.51Z" style="fill:#087abf"/></g></svg>',
            vehClass2: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120.59 20" width="120.59" height="20"><title>Vehicle Class 2</title><g id="vehClass2" data-name="vehClass2"><path d="M66.17,14.66h-.52v-.94l-.34-.56a2.72,2.72,0,0,0-2.69-2.32H56.51L54.53,7a1.39,1.39,0,0,0-1.23-.75H40.39a1,1,0,0,0-1,1V9.4h-1a.46.46,0,0,0-.45.46v4.69H26.86a14.31,14.31,0,0,0,7.3-4.76.25.25,0,0,0,0-.35l-.83-.62s-5.44-.29-7.37-.32h-1l-3.14-2.6A1,1,0,0,0,21,5.68C19.06,6,11.35,7.43,8.73,8.94a32.08,32.08,0,0,0-4.86,2.24l-2.07.15c-.61.15-1.33,1.11-1.74,1.73a.33.33,0,0,0,.28.52H1.91l.5,1v1.23H5.17a2.3,2.3,0,1,0,4.31,1.11,2.22,2.22,0,0,0-.3-1.11H38.56a.28.28,0,0,0,.26.23H40l1,.44h.53a2.85,2.85,0,0,0,0,.41,3.14,3.14,0,1,0,6.27,0h11.1a3.14,3.14,0,1,0,6.27,0,2.28,2.28,0,0,0,0-.26h1.11a.34.34,0,0,0,.37-.31V15A.34.34,0,0,0,66.17,14.66Z" style="fill:#087abf"/><path d="M120.49,13.94a1.65,1.65,0,0,0-.51-1,1.62,1.62,0,0,0-.06-.17.31.31,0,0,0-.09-.12,13.48,13.48,0,0,0-4.76-1.71,2,2,0,0,1-.53-.2h-.74A9.13,9.13,0,0,0,112.52,8a1.37,1.37,0,0,0-.16-.18,1.25,1.25,0,0,0-.46-.3,27.66,27.66,0,0,0-3.44-.74,4.61,4.61,0,0,1-1-.45,1.31,1.31,0,0,0-.48-.11c-.65,0-2.33,0-2.33,0L104,7.73v6.71h-.9V.76c0-.42-.25-.76-.55-.76H70.46c-.31,0-.56.34-.56.76V16.69c0,.27.11.49.38.49h6.84s0,.23,0,.35a2.39,2.39,0,1,0,4.78,0,2.85,2.85,0,0,0,0-.42h.47a2.85,2.85,0,0,0,0,.42,2.39,2.39,0,1,0,4.78,0,2.85,2.85,0,0,0,0-.42h1.9v.05a.8.8,0,0,0,.8.81h12.67a.8.8,0,0,0,.8-.81v-.05H104v1.62h8c.18,0,.28-.11.28-.48v-.72h.55a2.39,2.39,0,1,0,4.78,0H118c0,.17,0,.35,0,.52a.42.42,0,0,0,.41.4h.89a.9.9,0,0,0,.89-.91V15.72h.15a.19.19,0,0,0,.2-.21C120.58,15.15,120.54,14.43,120.49,13.94Z" style="fill:#087abf"/></g></svg>',
            vehClass3: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 61.06 18.79" width="61.06" height="18.79"><title>Vehicle Class 3</title><g id="vehClass3" data-name="vehClass3"><path d="M61.06,14.59c0-.33-.06-1-.1-1.48a1.51,1.51,0,0,0-.52-1,.77.77,0,0,0-.14-.27,13.75,13.75,0,0,0-4.67-1.61,2.14,2.14,0,0,1-.53-.18h-.73a8.43,8.43,0,0,0-1.25-2.57,1.35,1.35,0,0,0-.62-.45,29.23,29.23,0,0,0-3.37-.7,4.34,4.34,0,0,1-1-.42,1.25,1.25,0,0,0-.47-.11c-.64,0-2.29,0-2.29,0l-.6,1.44v5.48a6.61,6.61,0,0,1-.89,0V.71A.72.72,0,0,0,43.11,0H.73A.72.72,0,0,0,0,.71V15.56a.59.59,0,0,0,.6.6H4.34a1.87,1.87,0,0,0,0,.34A2.35,2.35,0,0,0,9,16.5,1.75,1.75,0,0,0,9,16.1h.43a2.58,2.58,0,0,0,0,.4,2.35,2.35,0,0,0,4.7,0,2.58,2.58,0,0,0,0-.4H28a2.58,2.58,0,0,0,0,.4,2.35,2.35,0,0,0,4.7,0,2.58,2.58,0,0,0,0-.4h.47a1.75,1.75,0,0,0,0,.4,2.35,2.35,0,0,0,4.65.41h5.22a1,1,0,0,0,1-.81h.84v1.53h8.05V16.57h.62a2.34,2.34,0,0,0,4.68,0h.45c0,.13,0,.26,0,.41a.39.39,0,0,0,.4.38h.88a.86.86,0,0,0,.87-.85V14.8h.15a.2.2,0,0,0,.2-.2" style="fill:#087abf"/></g></svg>',
            cscPin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 30" width="22px" height="30px"><path d="M9.933,0A11.046,11.046,0,0,0-1,11.2C-1,17.35,1.884,22.12,9.8,30h.4C18.116,22.051,21,17.419,21,11.2A11.2,11.2,0,0,0,9.933,0Z" transform="translate(1)" style="fill:#0079c2"/><g transform="translate(2.547 3.249)"><path d="M18.025,16.451C14.4,15,4.878,10.3,15.141,4.7c0,0-13.415,1.175-12.274,12.166H9.641C1.525,7.811,15.006,4.7,15.006,4.7,3.067,8.5,9.775,15.345,11.452,16.866h8.384l-1.543-.346C18.226,16.52,18.092,16.451,18.025,16.451Z" transform="translate(-2.797 -4.7)" style="fill:#ffffff"/></g></svg>',
            gantryPin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8" width="8px" height="8px"><circle cx="4" cy="4" r="4" style="fill:#00a160"/><circle cx="2" cy="2" r="2" transform="translate(2 2)" style="fill:#ffffff"/></svg>',
            routePin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="22px" height="22px"><circle cx="11" cy="11" r="11" style="fill:#95a0ad"/><circle cx="9" cy="9" r="9" transform="translate(2 1.92)" style="fill:#ffffff"/><circle cx="6" cy="6" r="6" transform="translate(5 4.92)" style="fill:#95a0ad"/></svg>',
            startPin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="22px" height="22px"><circle cx="11" cy="11" r="11" style="fill:#00a160"/><circle cx="9" cy="9" r="9" transform="translate(2 1.92)" style="fill:#ffffff"/><circle cx="6" cy="6" r="6" transform="translate(5 4.92)" style="fill:#00a160"/></svg>',
            endPin: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" width="22px" height="22px"><circle cx="11" cy="11" r="11" style="fill:#d31616"/><circle cx="9" cy="9" r="9" transform="translate(2 1.92)" style="fill:#ffffff"/><circle cx="6" cy="6" r="6" transform="translate(5 4.92)" style="fill:#d31616"/></svg>',
            zonePinI77: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#95a0ad"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">I-77 Express Lanes</tspan></text></g></svg>',
            zonePinHoverI77: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#666666"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">I-77 Express Lanes</tspan></text></g></svg>',
            shieldTri: '<svg xmlns="http://www.w3.org/2000/svg" width="62.938px" height="48.671px" viewBox="0 0 62.938 48.671"><g transform="translate(0.408)"><g transform="translate(31.608)"><path d="M80.751,48.08H53.641A1.634,1.634,0,0,1,52,46.439V1.641A1.634,1.634,0,0,1,53.641,0h27.11a1.634,1.634,0,0,1,1.641,1.641v44.8A1.634,1.634,0,0,1,80.751,48.08Z" transform="translate(-52)" style="fill:#fff;"/><path d="M80.761,18H56.873a.96.96,0,0,1-.973-.973V4.873a.96.96,0,0,1,.973-.973H80.761a.96.96,0,0,1,.973.973V17.029A.96.96,0,0,1,80.761,18Z" transform="translate(-53.529 -1.529)" style="fill:#f9d209;stroke:#000;stroke-width:2.238;stroke-miterlimit:10;"/><path d="M66.769,12.673h-1.4v3.89H64.4v-3.89H63V11.7h3.708v.973Z" transform="translate(-56.314 -4.588)"/><path d="M74.155,14.092c0,1.58-.851,2.492-2.127,2.492S69.9,15.673,69.9,14.092s.851-2.492,2.127-2.492C73.243,11.6,74.155,12.512,74.155,14.092Zm-1.033,0c0-.973-.486-1.52-1.155-1.52s-1.094.547-1.094,1.52.486,1.52,1.155,1.52S73.122,15.065,73.122,14.092Z" transform="translate(-59.02 -4.549)"/><path d="M81.8,16.6H78.4V11.8h.973v3.89H81.8Z" transform="translate(-62.353 -4.627)"/><path d="M88.8,16.6H85.4V11.8h.973v3.89H88.8Z" transform="translate(-65.098 -4.627)"/><path d="M82.212,58.075a1.349,1.349,0,0,1-1.337,1.337H54.737A1.349,1.349,0,0,1,53.4,58.075V31.937A1.349,1.349,0,0,1,54.737,30.6H80.875a1.349,1.349,0,0,1,1.337,1.337V58.075Z" transform="translate(-52.549 -12)" style="stroke:#fff;stroke-width:2.518;stroke-miterlimit:10;"/><path d="M69.424,58.459a1.322,1.322,0,0,1-1.824,0L55.565,46.424a1.322,1.322,0,0,1,0-1.824L67.6,32.565a1.322,1.322,0,0,1,1.824,0L81.459,44.6a1.322,1.322,0,0,1,0,1.824Z" transform="translate(-53.255 -12.627)" style="fill:#fff;"/><path d="M67.845,52.812c0,1.52-1.094,2.249-2.614,2.249a4.324,4.324,0,0,1-2.431-.669l.608-1.033a4.2,4.2,0,0,0,1.824.547c.851,0,1.337-.365,1.337-1.033s-.486-.912-1.033-.912a2.218,2.218,0,0,0-1.216.365L63.1,51.9l.243-3.1h4.194v1.216H64.5l-.061,1.094a2.719,2.719,0,0,1,1.337-.3A1.87,1.87,0,0,1,67.845,52.812Z" transform="translate(-56.235 -19.137)"/><path d="M77.971,53.684H77.12v1.276H75.9V53.684H72.5V52.529L75.843,48.7H77.18v3.829h.851v1.155Zm-2.006-3.525c-.122.182-.365.486-.547.729l-.912,1.033a3.325,3.325,0,0,1-.608.669H75.9V51.557C75.9,51.131,75.965,50.4,75.965,50.159Z" transform="translate(-60.039 -19.098)"/><path d="M88.127,51.722c0,1.884-.912,3.222-2.614,3.222S82.9,53.606,82.9,51.722s.912-3.222,2.614-3.222C87.155,48.561,88.127,49.837,88.127,51.722Zm-1.276.061c0-1.094-.425-2.006-1.337-2.006s-1.337.851-1.337,2.006c0,1.094.425,2.006,1.337,2.006S86.851,52.876,86.851,51.782Z" transform="translate(-64.118 -19.02)"/></g><path d="M28.751,48.08H1.641A1.634,1.634,0,0,1,0,46.439V1.641A1.634,1.634,0,0,1,1.641,0h27.11a1.634,1.634,0,0,1,1.641,1.641v44.8A1.634,1.634,0,0,1,28.751,48.08Z" style="fill:#fff;"/><path d="M28.761,18H4.873a.96.96,0,0,1-.973-.973V4.873A.96.96,0,0,1,4.873,3.9H28.761a.96.96,0,0,1,.973.973V17.029A.96.96,0,0,1,28.761,18Z" transform="translate(-1.529 -1.529)" style="fill:#f9d209;stroke:#000;stroke-width:2.238;stroke-miterlimit:10;"/><path d="M14.769,12.673h-1.4v3.89H12.4v-3.89H11V11.7h3.708v.973Z" transform="translate(-4.314 -4.588)"/><path d="M22.155,14.092c0,1.58-.851,2.492-2.127,2.492S17.9,15.673,17.9,14.092s.851-2.492,2.127-2.492C21.243,11.6,22.155,12.512,22.155,14.092Zm-1.033,0c0-.973-.486-1.52-1.155-1.52s-1.094.547-1.094,1.52.486,1.52,1.155,1.52S21.122,15.065,21.122,14.092Z" transform="translate(-7.02 -4.549)"/><path d="M29.8,16.6H26.4V11.8h.973v3.89H29.8Z" transform="translate(-10.353 -4.627)"/><path d="M36.8,16.6H33.4V11.8h.973v3.89H36.8Z" transform="translate(-13.098 -4.627)"/><path d="M30.212,58.075a1.349,1.349,0,0,1-1.337,1.337H2.737A1.349,1.349,0,0,1,1.4,58.075V31.937A1.349,1.349,0,0,1,2.737,30.6H28.875a1.349,1.349,0,0,1,1.337,1.337V58.075Z" transform="translate(-0.549 -12)" style="stroke:#fff;stroke-width:2.518;stroke-miterlimit:10;"/><path d="M17.424,58.459a1.322,1.322,0,0,1-1.824,0L3.565,46.424a1.322,1.322,0,0,1,0-1.824L15.6,32.565a1.322,1.322,0,0,1,1.824,0L29.459,44.6a1.322,1.322,0,0,1,0,1.824Z" transform="translate(-1.255 -12.627)" style="fill:#fff;"/><path d="M15.41,55H14.194V50.5H13.1V49.59c.669-.061,1.155-.3,1.276-.79H15.41Z" transform="translate(-5.137 -19.137)"/><path d="M24.271,53.684H23.42v1.276H22.2V53.684H18.8V52.529L22.143,48.7H23.48v3.829h.851v1.155Zm-2.006-3.525c-.122.182-.365.486-.547.729l-.912,1.033a3.325,3.325,0,0,1-.608.669H22.2V51.557A12.25,12.25,0,0,0,22.265,50.159Z" transform="translate(-7.373 -19.098)"/><path d="M33.28,49.916a6.664,6.664,0,0,0-2.067,5.045H29.937a7.543,7.543,0,0,1,1.824-5.045H28.6V48.7h4.68Z" transform="translate(-11.216 -19.098)"/></g></svg>',
            zonePinTri: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#0079c2"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">Triangle Expressway</tspan></text></g></svg>',
            zonePinHoverTri: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#00a160"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">Triangle Expressway</tspan></text></g></svg>',
            shieldMon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 31.019 60.595" width="31.019px" height="60.595px"><g transform="translate(0.421)"><path d="M28.257,59.994H1.8a1.768,1.768,0,0,1-1.8-1.8V1.8A1.768,1.768,0,0,1,1.8,0H28.2A1.768,1.768,0,0,1,30,1.8V58.134A1.736,1.736,0,0,1,28.257,59.994Z" style="fill:#fff;"/><path d="M28.557,41.459H4.38a.756.756,0,0,1-.78-.78v-8.1a.756.756,0,0,1,.78-.78H28.617a.756.756,0,0,1,.78.78v8.1A.773.773,0,0,1,28.557,41.459Z" transform="translate(-1.44 -12.722)" style="fill:#fff;stroke:#000;stroke-width:1.884;stroke-miterlimit:10;"/><path d="M10.2,40.5H8.7V37.2h1.5c.66,0,1.08.3,1.08.9a.914.914,0,0,1-.36.66.81.81,0,0,1,.48.72A1.065,1.065,0,0,1,10.2,40.5Zm0-2.76H9.36v.66h.9a.337.337,0,0,0,.36-.3C10.62,37.86,10.5,37.74,10.2,37.74Zm.06,1.2h-.9v.84h.9a.442.442,0,0,0,.48-.48A.467.467,0,0,0,10.26,38.94Z" transform="translate(-3.481 -14.882)"/><path d="M15.42,39.18V40.5h-.66V39.18L13.5,37.2h.78l.48.78c.12.18.3.54.36.66.06-.12.24-.48.36-.66l.48-.78h.78Z" transform="translate(-5.401 -14.882)"/><path d="M18.6,39.86V39.2h1.38v.66Z" transform="translate(-7.441 -15.682)"/><path d="M23.44,39.16h-.78V40.3H22V37h1.44a1.025,1.025,0,0,1,1.14,1.08C24.64,38.86,24.1,39.16,23.44,39.16Zm.06-1.44h-.78v.84h.78a.442.442,0,0,0,.48-.48A.419.419,0,0,0,23.5,37.72Z" transform="translate(-8.801 -14.802)"/><path d="M28.9,40.5l-.24-.78h-1.2l-.24.78H26.5l1.26-3.3h.66l1.26,3.3Zm-.66-1.98c-.06-.18-.18-.42-.18-.48a4.133,4.133,0,0,0-.18.48l-.18.6h.78Z" transform="translate(-10.602 -14.882)"/><path d="M33.62,40.38a1.63,1.63,0,0,1-1.32-.6l.48-.48a1.261,1.261,0,0,0,.84.42c.42,0,.6-.12.6-.36,0-.18-.12-.3-.78-.48-.6-.18-1.08-.36-1.08-1.02,0-.6.54-.96,1.2-.96a1.675,1.675,0,0,1,1.2.48l-.48.48a1.19,1.19,0,0,0-.78-.36c-.36,0-.48.18-.48.3,0,.18.18.24.66.42.54.12,1.08.3,1.08,1.02C34.88,39.96,34.52,40.38,33.62,40.38Z" transform="translate(-12.922 -14.762)"/><path d="M38.62,40.38a1.63,1.63,0,0,1-1.32-.6l.48-.48a1.261,1.261,0,0,0,.84.42c.42,0,.6-.12.6-.36,0-.18-.12-.3-.78-.48-.6-.18-1.08-.36-1.08-1.02,0-.6.54-.96,1.2-.96a1.675,1.675,0,0,1,1.2.48l-.48.48a1.19,1.19,0,0,0-.78-.36c-.36,0-.48.18-.48.3,0,.18.18.24.66.42.54.12,1.08.3,1.08,1.02C39.94,39.96,39.52,40.38,38.62,40.38Z" transform="translate(-14.922 -14.762)"/><path d="M29.837,78.577a1.332,1.332,0,0,1-1.32,1.32H2.72a1.332,1.332,0,0,1-1.32-1.32V52.72A1.332,1.332,0,0,1,2.72,51.4H28.577a1.332,1.332,0,0,1,1.32,1.32l-.06,25.857Z" transform="translate(-0.56 -20.563)" style="stroke:#fff;stroke-width:2.522;stroke-miterlimit:10;"/><path d="M17.759,78.538a5.4,5.4,0,0,0-4.08-1.92h-.96A6.145,6.145,0,0,1,6.6,70.5c0-2.1,1.38-3.6,1.38-5.759A6.869,6.869,0,0,0,6.6,60.6l4.38-4.2a5.169,5.169,0,0,0,3.36,1.26,5.455,5.455,0,0,0,3.42-1.26,5.33,5.33,0,0,0,3.42,1.26,5.421,5.421,0,0,0,3.36-1.26l4.38,4.26a7.139,7.139,0,0,0-1.38,4.14c0,2.16,1.38,3.66,1.38,5.759A6.145,6.145,0,0,1,22.8,76.678h-.96A5.339,5.339,0,0,0,17.759,78.538Z" transform="translate(-2.64 -22.563)" style="fill:#fff;"/><path d="M18.1,69.54H14.5V68.1h5.519v1.26L16.6,75.719H14.68Z" transform="translate(-5.801 -27.244)"/><path d="M29.16,74.059H25.44l-.24-1.2L29.4,68h1.38v4.68H31.8V74h-1.02v1.68H29.16v-1.62Zm0-1.32V70.4l-2.04,2.34Z" transform="translate(-10.082 -27.204)"/><path d="M28.438,17.739H4.92a1.051,1.051,0,0,1-1.02-1.02v-12A1.051,1.051,0,0,1,4.92,3.7H28.5a1.051,1.051,0,0,1,1.02,1.02v12A1.059,1.059,0,0,1,28.438,17.739Z" transform="translate(-1.56 -1.48)" style="fill:#f9d209;stroke:#000;stroke-width:2.24;stroke-miterlimit:10;"/><path d="M13.44,12.76v3.78h-.96V12.76H11.1V11.8h3.72v.96H13.44Z" transform="translate(-4.441 -4.721)"/><path d="M20.14,16.52c-1.32,0-2.04-1.02-2.04-2.46s.78-2.46,2.04-2.46,2.04,1.02,2.04,2.46S21.4,16.52,20.14,16.52Zm0-3.96c-.78,0-1.08.66-1.08,1.5s.3,1.5,1.08,1.5,1.08-.66,1.08-1.5S20.86,12.56,20.14,12.56Z" transform="translate(-7.241 -4.641)"/><path d="M26.5,16.54V11.8h.96v3.78h2.4v.96H26.5Z" transform="translate(-10.602 -4.721)"/><path d="M33.6,16.54V11.8h.96v3.78h2.4v.96H33.6Z" transform="translate(-13.442 -4.721)"/></g></svg>',
            zonePinMon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#0079c2"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">Monroe Expressway</tspan></text></g></svg>',
            zonePinHoverMon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 180 58.952" width="180px" height="58.952px"><g transform="translate(-582 -606)"><g transform="translate(590 658)"><g transform="translate(3.964 2.964)"><circle cx="5" cy="5" r="5" transform="translate(3 -6.012)" style="fill:#ffffff"/></g><path d="M-2054-186a3,3,0,0,1,1.66-2.685L-2060.979-206H-2071v-34h180v34h-150.062l-8.6,17.313A3,3,0,0,1-2048-186a3,3,0,0,1-3,3A3,3,0,0,1-2054-186Z" transform="translate(2063 188)" style="fill:#00a160"/></g><text transform="translate(672 628)" style="font: bold .9rem Arial;fill:#ffffff"><tspan x="-71.379" y="0">Monroe Expressway</tspan></text></g></svg>',
        },
        ncMask: String.raw`POLYGON((-110 10,-50 10,-50 60,-110 60,-110 10),
(-84.33074 34.98985,-84.29547 35.20719,-84.29209 35.22802,-84.29175 35.2294,-84.2912 35.2307,-84.29045 35.23191,-84.28953 35.23298,-84.28844 35.23389,-84.22894 35.27639,-84.22781 35.27708,-84.22659 35.27759,-84.2253 35.27792,-84.22399 35.27806,-84.22266 35.278,
-84.22136 35.27775,-84.22011 35.27731,-84.21894 35.27669,-84.17628 35.24988,-84.10052 35.25614,-84.03402 35.29964,-84.03392 35.29971,-84.04674 35.34596,-84.047 35.34727,-84.04706 35.3486,-84.04693 35.34993,-84.0466 35.35122,-84.04608 35.35245,-84.04539 35.35359,
-84.04453 35.35461,-84.04353 35.3555,-84.01845 35.37467,-84.03013 35.40411,-84.03053 35.40539,-84.03074 35.40672,-84.03074 35.40807,-84.03054 35.4094,-84.03015 35.41069,-84.02957 35.4119,-84.02881 35.41301,-84.02789 35.414,-83.97928 35.45916,-83.97789 35.46023,
-83.97631 35.461,-83.96202 35.46632,-83.95626 35.46848,-83.95625 35.46849,-83.92092 35.48166,-83.85349 35.52673,-83.85288 35.5271,-83.77612 35.56996,-83.77488 35.57054,-83.77356 35.57092,-83.77221 35.57109,-83.66336 35.57677,-83.65363 35.57728,-83.65297 35.57729,
-83.58764 35.57594,-83.58743 35.57593,-83.50152 35.57211,-83.45833 35.6097,-83.45724 35.61051,-83.45604 35.61115,-83.45476 35.6116,-83.42532 35.61949,-83.35222 35.66796,-83.35097 35.66865,-83.34962 35.66914,-83.34821 35.6694,-83.34677 35.66944,-83.30159 35.66699,
-83.27194 35.70846,-83.2635 35.72028,-83.26349 35.7203,-83.26265 35.72147,-83.26174 35.72255,-83.26067 35.72347,-83.25946 35.72422,-83.25816 35.72476,-83.25679 35.7251,-83.20265 35.73388,-83.16799 35.76961,-83.16697 35.77052,-83.16583 35.77125,-83.16459 35.77181,
-83.16328 35.77217,-83.09911 35.78485,-83.05062 35.79645,-83.04926 35.79666,-83.04788 35.79667,-82.98209 35.79188,-82.97317 35.80162,-82.94427 35.83316,-82.90937 35.8769,-82.9194 35.9251,-82.91958 35.92647,-82.91955 35.92785,-82.9193 35.92921,-82.91885 35.93052,
-82.9182 35.93174,-82.91737 35.93285,-82.91638 35.93381,-82.91526 35.93462,-82.91402 35.93524,-82.89728 35.94212,-82.86413 35.95574,-82.86289 35.95615,-82.8616 35.95637,-82.8603 35.9564,-82.859 35.95625,-82.85774 35.9559,-82.85654 35.95538,-82.81775 35.93499,
-82.79573 35.95663,-82.78821 35.99427,-82.78783 35.99561,-82.78725 35.99688,-82.78648 35.99804,-82.78554 35.99907,-82.78445 35.99994,-82.78324 36.00063,-82.7289 36.02632,-82.72877 36.02638,-82.63207 36.07029,-82.63075 36.07077,-82.62936 36.07104,-82.62795 36.07108,
-82.62655 36.07091,-82.62519 36.07052,-82.62391 36.06991,-82.62274 36.06912,-82.62171 36.06815,-82.59909 36.04328,-82.58888 36.03206,-82.58806 36.03102,-82.58741 36.02987,-82.58693 36.02865,-82.58664 36.02736,-82.58654 36.02605,-82.58663 36.02473,-82.58691 36.02345,
-82.5999 35.97982,-82.55858 35.96381,-82.51228 35.98992,-82.4707 36.01336,-82.42425 36.07818,-82.41676 36.08864,-82.41584 36.08974,-82.41475 36.09067,-82.41353 36.09142,-82.35093 36.12322,-82.34999 36.12363,-82.30079 36.14193,-82.29924 36.14235,-82.29763 36.14249,
-82.29603 36.14234,-82.26731 36.13704,-82.22475 36.16159,-82.21574 36.16679,-82.21438 36.16743,-82.21294 36.16783,-82.21144 36.16799,-82.20995 36.1679,-82.20848 36.16756,-82.13808 36.14477,-82.13668 36.14417,-82.13539 36.14335,-82.13426 36.14232,-82.13332 36.14112,
-82.1326 36.13977,-82.12131 36.11357,-82.08183 36.11466,-82.03459 36.13176,-81.96759 36.23308,-81.96745 36.2333,-81.94172 36.26989,-81.9258 36.29252,-81.91549 36.30718,-81.91471 36.30814,-81.9138 36.30898,-81.91279 36.3097,-81.83785 36.35503,-81.83656 36.35567,
-81.83519 36.3561,-81.83376 36.35631,-81.83232 36.35628,-81.76836 36.35001,-81.71918 36.34802,-81.73364 36.3862,-81.74271 36.41016,-81.74312 36.41157,-81.74329 36.41303,-81.74322 36.4145,-81.74291 36.41593,-81.74237 36.4173,-81.74162 36.41856,-81.70449 36.47052,
-81.70892 36.53623,-81.7089 36.53766,-81.70866 36.53907,-81.70819 36.54043,-81.68577 36.59172,-81.68514 36.59291,-81.68433 36.594,-81.68337 36.59495,-81.68228 36.59575,-81.68108 36.59638,-81.6798 36.59681,-81.67847 36.59705,-81.67712 36.59709,-81.49951 36.5888,
-81.35291 36.58522,-81.17649 36.58091,-81.17633 36.5809,-81.06153 36.576,-80.9017 36.57073,-80.84024 36.57091,-80.70486 36.5713,-80.70443 36.57129,-80.61179 36.56719,-80.4397 36.55957,-80.43121 36.55919,-80.4312 36.55919,-80.29501 36.55295,-80.0534 36.55162,
-80.02723 36.55148,-79.89154 36.55101,-79.71483 36.55041,-79.51094 36.54972,-79.51066 36.54972,-79.47017 36.54982,-79.3427 36.55012,-79.21866 36.55042,-79.13796 36.55062,-78.94203 36.55109,-78.94199 36.55109,-78.79628 36.55074,-78.7341 36.55059,-78.50998 36.55005,
-78.4575 36.55043,-78.32371 36.5514,-78.13298 36.55279,-78.13295 36.55279,-78.04624 36.55318,-77.89981 36.55383,-77.76714 36.55442,-77.74975 36.5545,-77.74972 36.5545,-77.29878 36.55502,-77.19018 36.55514,-77.19017 36.55514,-77.16435 36.55513,-76.91743 36.55503,
-76.9163 36.55506,-76.916 36.55507,-76.91598 36.55507,-76.73858 36.55996,-76.73832 36.55996,-76.54159 36.55976,-76.49147 36.55971,-76.3132 36.55953,-76.02676 36.55953,-75.86705 36.55973,-75.86556 36.55961,-75.86412 36.55924,-75.86275 36.55864,-75.86151 36.55783,
-75.86041 36.55681,-75.8595 36.55563,-75.8588 36.55432,-75.85832 36.5529,-75.82976 36.43723,-75.78795 36.29343,-75.76243 36.23571,-75.71037 36.11794,-75.65098 36.02528,-75.65072 36.02485,-75.56197 35.86772,-75.56188 35.86756,-75.51114 35.77343,-75.48827 35.73294,
-75.4878 35.73198,-75.48745 35.73097,-75.45002 35.59905,-75.44976 35.59784,-75.44968 35.59661,-75.44976 35.59538,-75.47787 35.39043,-75.47813 35.38921,-75.52499 35.22339,-75.52547 35.22208,-75.52614 35.22086,-75.527 35.21977,-75.52802 35.21882,-75.52917 35.21803,
-75.53043 35.21744,-75.53176 35.21704,-75.53314 35.21686,-75.63392 35.21135,-75.74695 35.17702,-75.75491 35.17461,-75.90903 35.11152,-76.0086 35.05411,-76.132 34.98054,-76.22723 34.89867,-76.22799 34.89808,-76.30466 34.84522,-76.38048 34.77818,-76.44337 34.70888,
-76.52852 34.58353,-76.52937 34.58247,-76.53036 34.58154,-76.53149 34.58078,-76.53272 34.5802,-76.53402 34.57981,-76.53537 34.57962,-76.53673 34.57963,-76.53807 34.57985,-76.53936 34.58027,-76.54058 34.58088,-76.54169 34.58167,-76.54267 34.58262,-76.54349 34.5837,
-76.54414 34.58489,-76.56096 34.62226,-76.62236 34.66416,-76.72762 34.68763,-76.90496 34.67391,-77.11106 34.62931,-77.13407 34.62434,-77.23676 34.57956,-77.31769 34.52799,-77.31878 34.5274,-77.45858 34.46346,-77.51033 34.42985,-77.62958 34.35239,-77.70756 34.28352,
-77.75746 34.23945,-77.82147 34.15793,-77.88891 34.00881,-77.90724 33.96828,-77.92642 33.91738,-77.95176 33.85015,-77.9524 33.84881,-77.95325 33.84759,-77.95429 33.84653,-77.95549 33.84565,-77.95682 33.84498,-77.95824 33.84455,-77.95971 33.84435,-77.9612 33.8444,
-78.00779 33.84978,-78.00914 33.85004,-78.01043 33.8505,-78.01164 33.85116,-78.01274 33.85199,-78.01369 33.85298,-78.01448 33.85411,-78.01509 33.85534,-78.02521 33.88044,-78.13785 33.9032,-78.27572 33.90338,-78.38212 33.8931,-78.53832 33.84256,-78.5396 33.84225,
-78.54091 33.84213,-78.54222 33.8422,-78.5435 33.84246,-78.54474 33.8429,-78.5459 33.84352,-78.54695 33.8443,-78.62176 33.90869,-78.65669 33.93821,-78.8175 34.07414,-79.07695 34.29237,-79.07702 34.29242,-79.36409 34.53847,-79.45597 34.61366,-79.46766 34.62322,
-79.67856 34.7958,-79.69306 34.79598,-79.92442 34.79884,-79.92445 34.79884,-79.92772 34.79889,-80.07733 34.80074,-80.07736 34.80074,-80.32056 34.80463,-80.56181 34.8085,-80.56191 34.8085,-80.62602 34.81024,-80.79724 34.81489,-80.7986 34.81503,-80.79993 34.81538,
-80.80118 34.81592,-80.80234 34.81665,-80.80338 34.81754,-80.80426 34.81858,-80.80498 34.81975,-80.80551 34.82101,-80.80585 34.82233,-80.80598 34.82369,-80.8059 34.82506,-80.79149 34.93288,-80.84727 34.99549,-80.91295 35.0692,-80.93675 35.09593,-81.03693 35.03696,
-81.03821 35.03634,-81.03956 35.03593,-81.04096 35.03573,-81.04238 35.03576,-81.04377 35.03601,-81.0451 35.03648,-81.04635 35.03715,-81.04748 35.038,-81.04845 35.03903,-81.04926 35.04019,-81.0658 35.06868,-81.0664 35.06994,-81.06681 35.07127,-81.067 35.07266,
-81.06697 35.07405,-81.06673 35.07542,-81.06628 35.07674,-81.04617 35.12341,-81.0501 35.14059,-81.3285 35.15331,-81.36802 35.15512,-81.49463 35.1609,-81.76841 35.17073,-81.87443 35.17453,-81.96965 35.17795,-82.03991 35.18047,-82.04858 35.18066,-82.21644 35.18428,
-82.29554 35.18599,-82.29593 35.18601,-82.3536 35.18974,-82.40921 35.19334,-82.45119 35.16961,-82.45215 35.16914,-82.45316 35.16879,-82.53011 35.14698,-82.53078 35.14682,-82.57593 35.13768,-82.68227 35.11615,-82.74103 35.07195,-82.74227 35.07117,-82.74363 35.0706,
-82.74505 35.07025,-82.74652 35.07015,-82.74798 35.07028,-82.76362 35.07302,-82.78292 35.07641,-82.89523 35.04733,-83.00615 35.01824,-83.10633 34.99197,-83.10841 34.99168,-83.32253 34.98689,-83.48242 34.9819,-83.5489 34.97982,-83.6197 34.97761,-83.62001 34.97761,
-83.93644 34.9785,-83.93678 34.9785,-83.93685 34.97851,-84.00553 34.97867,-84.12946 34.97897,-84.32189 34.97943,-84.3233 34.97954,-84.32467 34.97987,-84.32597 34.98042,-84.32717 34.98116,-84.32824 34.98208,-84.32915 34.98315,-84.32989 34.98436,-84.33042 34.98566,
-84.33075 34.98704,-84.33085 34.98844,-84.33074 34.98985))`,
        directions: {
            container: document.getElementById('mapDirContainer'),
            panel: document.getElementById('mapDirPanel'),
            itinerary: document.getElementById('mapDirItinerary'),
            link: document.getElementById('mapDirLink'),
        },
    },
    style: {
        // may decide to add pin options here depending on how often they might get referenced below
        // consider adding as RGBa
        color: {
            ncqpBlue: '#0079c2',
            ncqpGreen: '#00a160',
            ncqpRed: '#d10000',
            ncqpGray: '#95a0ad',
        },
        pushpinOptions: {
            color: {
                ncqpBlue: '#0079c2',
                ncqpGreen: '#00a160',
                ncqpRed: '#d10000',
                ncqpGray: '#95a0ad',
            },
        },
        polylineOptions: {
            color: {
                ncqpBlue: '#0079c2',
                ncqpGreen: '#00a160',
                ncqpRed: '#d10000',
                ncqpGray: '#95a0ad',
            },
        },
        polygonOptions: {
            fillColor: 'rgba(208, 248, 208, 0.25)',
            strokeColor: 'transparent',
        },
    },
    loadMap: function() {
        // Bail early if no div.
        if (!this.ele.mapDiv) {
            return;
        }

        this.options.navigationBarMode = this.api.Maps.NavigationBarMode.minified;
        this.options.mapTypeId = this.api.Maps.MapTypeId.road;
        this.options.center = new this.api.Maps.Location(this.location.lat, this.location.long);

        map = new this.api.Maps.Map(this.ele.mapDiv, this.options);
        this.map = map;
        this.createMapMask(this.api, this.map, this.ele.ncMask);

        //log(this.map.getBounds()); // initial bounds

        // this should only fire once!
        if (tollMap.data.zonePinLayer === null) {
            this.createZonePins(this.api, this.map);
            // log('createZonePins called from loadMap');
        }
        return;
    },
    createMapMask: function(api, map, mask) {
        api.Maps.loadModule('Microsoft.Maps.WellKnownText', function() {
            // using String.raw on ele.ncMask object above...might be problem for IE users, aka no support
            var maskPolygon = api.Maps.WellKnownText.read(mask, {
                polygonOptions: {
                    fillColor: 'rgba(208, 248, 208, 0.35)',
                    strokeColor: 'transparent',
                },
            });
            // use add layer instead and move away from entity collection
            map.entities.push(maskPolygon);
        });
        return;
    },
    createZonePins: function(api, map) {
        // Create a layer for pins, and add them to it
        var triPin, triPoly, monPin, monPoly, i77Pin, zonePins = [],
            triPinLoc = new api.Maps.Location(tollMap.location.triExp.lat, tollMap.location.triExp.lon),
            monPinLoc = new api.Maps.Location(tollMap.location.monExp.lat, tollMap.location.monExp.lon),
            i77PinLoc = new api.Maps.Location(tollMap.location.i77Exp.lat, tollMap.location.i77Exp.lon);
        var i77Infobox = new Microsoft.Maps.Infobox(i77PinLoc, {
            htmlContent: tollMap.templates.i77Infobox,
            offset: new Microsoft.Maps.Point(-55, -10),
        });
        triPin = new api.Maps.Pushpin(triPinLoc, {
            icon: tollMap.ele.svg.zonePinTri,
            anchor: new api.Maps.Point(20, 58),
        });
        monPin = new api.Maps.Pushpin(monPinLoc, {
            icon: tollMap.ele.svg.zonePinMon,
            anchor: new api.Maps.Point(20, 58),
        });
        i77Pin = new api.Maps.Pushpin(i77PinLoc, {
            icon: tollMap.ele.svg.zonePinI77,
            anchor: new api.Maps.Point(20, 58),
        });
        // add pins to pin array
        zonePins.push(triPin, monPin, i77Pin);
        // create a layer to add them to
        if (tollMap.data.zonePinLayer == null) {
            tollMap.data.zonePinLayer = new api.Maps.Layer('ZonePinLayer');
            map.layers.insert(tollMap.data.zonePinLayer);
            tollMap.data.zonePinLayer.add(zonePins);
        }
        // add polylines to the map for tollroads that do not represent
        api.Maps.loadModule('Microsoft.Maps.GeoJson', function() {
            triPoly = api.Maps.GeoJson.read(tollMap.data.triExpGeoJson, {
                pushpinOptions: {
                    visible: false,
                },
            });
            for (var i = 0; i < triPoly.length; i++) {
                triPoly[i].setOptions({
                    strokeColor: '#b8c4cc',
                    strokeThickness: 2,
                });
                if (triPoly[i].metadata.exitId) {
                    triPoly[i].setOptions({
                        visible: false,
                    });
                } else if (triPoly[i].metadata.title) {
                    triPoly[i].setOptions({
                        visible: false,
                    });
                }
                tollMap.data.zonePinLayer.add(triPoly);
            }
            monPoly = api.Maps.GeoJson.read(tollMap.data.monExpGeoJson, {
                pushpinOptions: {
                    visible: false,
                },
            });
            for (var j = 0; j < monPoly.length; j++) {
                monPoly[j].setOptions({
                    strokeColor: '#b8c4cc',
                    strokeThickness: 2,
                });
                if (monPoly[j].metadata.exitId) {
                    monPoly[j].setOptions({
                        visible: false,
                    });
                } else if (monPoly[j].metadata.title) {
                    monPoly[j].setOptions({
                        visible: false,
                    });
                }
                tollMap.data.zonePinLayer.add(monPoly);
            }
        });
        // event handlers
        api.Maps.Events.addHandler(tollMap.data.zonePinLayer, 'mouseover', function(e) {
            if (e.target.getLocation().latitude == tollMap.location.triExp.lat) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.zonePinHoverTri,
                });
            }
            if (e.target.getLocation().latitude == tollMap.location.monExp.lat) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.zonePinHoverMon,
                });
            }
            if (e.target.getLocation().latitude == tollMap.location.i77Exp.lat) {
                //Assign the infobox to the map
                i77Infobox.setMap(this.map);
            }
        });
        api.Maps.Events.addHandler(tollMap.data.zonePinLayer, 'mouseout', function(e) {
            if (e.target.getLocation().latitude == tollMap.location.triExp.lat) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.zonePinTri,
                });
            }
            if (e.target.getLocation().latitude == tollMap.location.monExp.lat) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.zonePinMon,
                });
            }
            if (e.target.getLocation().latitude == tollMap.location.i77Exp.lat) {
                // remove the infobox
                i77Infobox.setMap(null);
                e.target.setOptions({
                    icon: tollMap.ele.svg.zonePinI77,
                });
            }
        });
        api.Maps.Events.addHandler(tollMap.data.zonePinLayer, 'click', function(e) {
            tollMap.data.zonePinLayer.setVisible(false);
            window.setTimeout(function() {
                tollMap.setExpMap(e);
            }, 100);
        });
    },
    setExpMap: function(e) {
        // log('setExpMap called from createZonePins event');

        // does it make sense to make a coord func that's accessible to other func?
        // or is it better to put these up in the location object?
        var triPinLoc = new Microsoft.Maps.Location(tollMap.location.triExp.lat, tollMap.location.triExp.lon),
            monPinLoc = new Microsoft.Maps.Location(tollMap.location.monExp.lat, tollMap.location.monExp.lon),
            i77PinLoc = new Microsoft.Maps.Location(tollMap.location.i77Exp.lat, tollMap.location.i77Exp.lon),
            loc = e.target.getLocation().longitude
        /*,
                    mapBounds = this.map.getBounds(),
                    monBounds = Microsoft.Maps.LocationRect.fromCorners(new Microsoft.Maps.Location(35.097755, -80.675268), new Microsoft.Maps.Location(34.984264, -80.401854))*/
        ;

        // possibly add a setTimeout() after case statement, to make a nicer transition
        switch (loc) {
            case tollMap.location.triExp.lon:
                tollMap.map.setView({
                    zoom: 11,
                    center: triPinLoc,
                    centerOffset: new Microsoft.Maps.Point(5, 0),
                });
                tollMap.setExpPinsPolys(Microsoft, this.map, tollMap.data.triExpGeoJson);
                break;
            case tollMap.location.monExp.lon:
                tollMap.map.setView({
                    zoom: 11,
                    center: monPinLoc,
                    centerOffset: new Microsoft.Maps.Point(10, 10),
                });
                /*this.map.setView({ zoom: 13, bounds: monBounds, padding: 0 });
                var boundsBorder = new Microsoft.Maps.Polyline([monBounds.getNorthwest(),
                    new Microsoft.Maps.Location(monBounds.getNorthwest().latitude, monBounds.getSoutheast().longitude),
                    monBounds.getSoutheast(),
                    new Microsoft.Maps.Location(monBounds.getSoutheast().latitude, monBounds.getNorthwest().longitude),
                    monBounds.getNorthwest()], { strokeColor: 'red', strokeThickness: 5 });
                this.map.entities.push(boundsBorder);*/
                //this.map = new Microsoft.Maps.Map(tollMap.ele.mapDiv, {zoom: null, maxBounds: monBounds});
                tollMap.setExpPinsPolys(Microsoft, this.map, tollMap.data.monExpGeoJson);
                break;
            case tollMap.location.i77Exp.lon:
                // replace with url to external site or infobox that states no rate data w/ link in desc
                tollMap.map.setView({
                    zoom: 10,
                    center: i77PinLoc,
                });
                tollMap.setExpPinsPolys(Microsoft, this.map, tollMap.data.i77ExpGeoJson);
                //tollMap.createTollPanel(Microsoft,this.map,tollMap.location,tollMap.data.i77ExpGeoJson);
                // add infobox
                /*var i77Infobox = new Microsoft.Maps.Infobox(i77PinLoc, {
                    title: 'I-77 Express Lanes',
                    description: 'Please visit' + ' ' + 'www.i77express.com for toll rate information',
                    showPointer: false,
                    showCloseButton: false,
                    offset: new Microsoft.Maps.Point(-125, 0)
                });
                //Assign the infobox to a map instance.
                i77Infobox.setMap(this.map);*/
                break;
        }
        // zoom is not an effective filter! Also might add handler for drag so infobox stays vis
        var currentZoom = tollMap.map.getZoom();
        if (e.targetType == 'layer' && currentZoom == 11) {
            Microsoft.Maps.Events.addHandler(this.map, 'click', tollMap.resetMap);
        }
    },
    setExpPinsPolys: function(api, map, data) {
        // log('setExpPinsPolys called from setExpMap');
        // log(data);
        // log(tollMap.map.getZoom());
        // log(tollMap.map.getBounds()); // monroe exp bounds

        //var bounds = Microsoft.Maps.LocationRect.fromLocations(new Microsoft.Maps.Location(35.097755, -80.675268), new Microsoft.Maps.Location(34.984264, -80.401854)),

        // set pin and polyline data and place them in separate layers
        if (tollMap.data.expDataLayer == null) {
            tollMap.data.expDataLayer = new api.Maps.Layer('ExpDataLayer');
            map.layers.insert(tollMap.data.expDataLayer);
        }
        if (tollMap.data.expExitDataLayer == null) {
            tollMap.data.expExitDataLayer = new api.Maps.Layer('ExpExitDataLayer');
            map.layers.insert(tollMap.data.expExitDataLayer);
        } else if (tollMap.data.expExitDataLayer == null && data == tollMap.data.i77ExpGeoJson) {
            //tollMap.data.expExitDataLayer == null;
            // log('no exits here');
        }
        // shouldn't need these anymore
        if (tollMap.data.expDataLayer != null && tollMap.data.expDataLayer.getVisible() == false) {
            tollMap.data.expDataLayer.setVisible(true);
        }
        if (tollMap.data.expExitDataLayer != null && tollMap.data.expExitDataLayer.getVisible() == false) {
            tollMap.data.expExitDataLayer.setVisible(true);
        }

        api.Maps.loadModule('Microsoft.Maps.GeoJson', function() {
            // can toFixed(5); be helpful here to trim coord lengths?
            var exitPins = [],
                routeData = [],
                mouseOver, mouseOutStart, startClick, endZoom;
            var expData = api.Maps.GeoJson.read(data, {
                pushpinOptions: {
                    //icon: '',
                    icon: tollMap.ele.svg.gantryPin,
                    cursor: 'arrow',
                    anchor: new api.Maps.Point(4, 4),
                },
            });

            for (var i = 0; i < expData.length; i++) {
                expData[i].setOptions({
                    strokeColor: tollMap.style.color.ncqpBlue,
                    strokeThickness: 6,
                });
                if (expData[i].metadata.exitId) {
                    expData[i].setOptions({
                        icon: tollMap.ele.svg.routePin,
                        cursor: 'pointer',
                        anchor: new api.Maps.Point(11, 11),
                    });
                } else if (expData[i].metadata.title) {
                    expData[i].setOptions({
                        icon: tollMap.ele.svg.cscPin,
                        cursor: 'pointer',
                        anchor: new api.Maps.Point(11, 30),
                    });
                }

            }
            // separate data and add to the new layers, leaving expData out of them (non-destructive)
            for (var j = 0; j < expData.length; j++) {
                if (expData[j].metadata.exitId) {
                    exitPins.push(expData[j]);
                } else {
                    routeData.push(expData[j]);
                }
            }

            // Add to separate layers
            tollMap.data.expDataLayer.add(routeData); //log(tollMap.data.expDataLayer);
            tollMap.data.expExitDataLayer.add(exitPins); //log(tollMap.data.expExitDataLayer);

            // Add change handler to hide gantry pins when zoomed to <= 11
            endZoom = api.Maps.Events.addHandler(map, 'viewchangeend', function(e) {
                var currentZoom = map.getZoom();

                if (currentZoom <= 11) {
                    for (var k = 0; k < routeData.length; k++) {
                        if (routeData[k].metadata.zoneId == 'gantryZones') {
                            routeData[k].setOptions({
                                visible: false,
                            });
                        }
                    }
                } else if (currentZoom > 11) {
                    for (var l = 0; l < routeData.length; l++) {
                        if (routeData[l].metadata.zoneId == 'gantryZones') {
                            routeData[l].setOptions({
                                visible: true,
                            });
                        }
                    }
                }
            });
            // Initiate the toll panel -- use setTimeOut() and then fade in or slide down, etc
            if (tollMap.data.expDataLayer != null) { // add filter for i77 data to prevent it from making call?
                tollMap.createTollPanel(Microsoft, this.map, tollMap.location, exitPins);
            }

        });
        // INSTEAD OF FLAGS, COULD USE INFOBOX AS TOOLTIP WHILE HOVERING PINS -- will reveist this
        mouseOver = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'mouseover', function(e) {
            if (tollMap.exitSelected) {
                return;
            }

            var entryOptList = document.getElementById('entryPointList'),
                entryOptionList = document.querySelectorAll('#entryPointList > .option'),
                exitOptList = document.getElementById('exitPointList'),
                exitOptionList = document.querySelectorAll('#exitPointList > .option');

            if (tollMap.data.expTollLayer == null) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.startPin,
                    title: e.target.metadata.exitName,
                });
                // now show the entry input
                window.setTimeout(function() {
                    var entryDivId = document.getElementById('entryPoint' + e.target.metadata.routeName.replace(/\s+/g, '')),
                        entrySelect = document.querySelector('#' + entryDivId.id + '.inputSelect.hidden');
                    if (entrySelect) {
                        entrySelect.classList.remove('hidden');
                    }
                }, 300);
            } else {
                e.target.setOptions({
                    icon: tollMap.ele.svg.endPin,
                    title: e.target.metadata.exitName,
                });
            }
        });
        // if opt list then need to reset span val here
        mouseOutStart = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'mouseout', function(e) {
            e.target.setOptions({
                icon: tollMap.ele.svg.routePin,
                title: '',
            });
        });
        startClick = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'click', function(e) {
            var select = document.querySelector('select'),
                entryOptList = document.getElementById('entryPointList'),
                entryOptionList = document.querySelectorAll('#entryPointList > .option'),
                exitOptionList = document.querySelectorAll('#exitPointList > .option'),
                value = document.querySelector('.value');

            e.target.setOptions({
                icon: tollMap.ele.svg.startPin,
                title: '',
            });

            document.querySelector('#vehicleClassList').classList.add('hidden');
            document.querySelector('#vehicleClassList').parentNode.classList.add('complete');

            api.Maps.Events.removeHandler(mouseOutStart);
            // match dropdown value with this target
            // might need to account for vc list option
            if (tollMap.data.expTollLayer == null) {
                if (entryOptList.previousElementSibling.dataset.bool == 'false') {
                    entryOptList.classList.add('hidden');
                    entryOptList.parentNode.classList.add('complete');

                    entryOptionList.forEach(function(option, index) { // li for each ul

                        if (e.target.metadata.exitName == option.innerText && option.dataset.option == 'enter') {
                            //log(entryOptList); // ul with id #ePL
                            entryOptList.previousElementSibling.innerText = option.innerText; // updates the span value
                            entryOptList.previousElementSibling.dataset.bool = 'true'; // update its data-bool
                        }
                        for (var i = 0; i < exitOptionList.length; i++) {
                            // if target option matches, hide the option in the select list
                            if (e.target.metadata.exitName == exitOptionList[i].innerText) {
                                exitOptionList[i].classList.add('hidden');
                            }
                        }
                    });
                }
                // now show the exit input
                window.setTimeout(function() {
                    var exitSelect = document.querySelector('.inputSelect.hidden');
                    exitSelect.classList.remove('hidden');
                }, 300);

                tollMap.setTollStart(e, Microsoft, map);
            }
        });
    },
    createTollPanel: function(api, map, loc, data) {
        // log('createTollPanel called from setExpPinsPolys');

        // Define an HTML template for a custom infobox.
        var tollPanel, tollPanelTemplate, entrySelectTemplate, exitSelectTemplate, resultTemplate, resetBtn, panel, zoneIcon,
            title = data[0].metadata.routeName,
            selectItems = [],
            listItems = [],
            exitSelectItems = [],
            exitListItems = [];

        tollPanelTemplate = '<div class="customInfobox">' +
            //'<div class="zone-icon">' + tollMap.ele.svg.zonePinMon + '</div>' +
            //'<div class="zone-icon">{zoneIcon}</div>' +
            //'<div class="customInfobox">' +
            '<div class="title">' +
            '<a id="resetToll" class="resetLink">Reset ' + tollMap.ele.svg.resetIcon + '</a>' +
            '<label>Route</label><h4>{title}</h4></div>' +
            '<form class="inputFields no-widget">' +
            '<div class="inputSelect">' +
            '<label>Vehicle Class</label>' +
            '<select id="vehicleClass" name="vehicleClass" placeholder="Please select a vehicle class">' +
            '<option value="Class 1 (two axles)">Class 1 (two axles)</option>' +
            '<option value="Class 2 (three axles)">Class 2 (three axles)</option>' +
            '<option value="Class 3 (four or more axles)">Class 3 (four or more axles)</option>' +
            '</select>' +
            '<div class="select centered" role="listbox">' +
            //'<span class="value">Class 1 (two axles) ' + tollMap.ele.svg.vehClass1 + '</span>' +
            //'<ul id="vehicleClassList" class="optList hidden" role="presentation">' +
            '<span class="value" data-bool="false">Please select a vehicle class</span>' +
            '<ul id="vehicleClassList" class="optList" role="presentation">' +
            //'<ul id="vehicleClassList" class="optList hidden" role="presentation">' +
            //'<li class="option" role="option" aria-selected="true">Please select a vehicle class</li>' +
            '<li class="option" data-option="vehicle-class" role="option">Class 1 (two axles) ' + tollMap.ele.svg.vehClass1 + '</li>' +
            '<li class="option" data-option="vehicle-class" role="option">Class 2 (three axles) ' + tollMap.ele.svg.vehClass2 + '</li>' +
            '<li class="option" data-option="vehicle-class" role="option">Class 3 (four or more axles) ' + tollMap.ele.svg.vehClass3 + '</li>' +
            '</ul></div></div>' +
            '{entrySelects}' +
            '{exitSelects}' +
            '</form>' +
            '{result}' +
            '</div>';

        entrySelectTemplate = '<div id="entryPoint{inputId}" class="inputSelect hidden">' +
            '<label>Entry <div class="inputPin"><a href="#" class="entryPinLink">' + tollMap.ele.svg.routePin + '</a></div></label>' +
            '<select id="entryPoint" name="entryPoint" placeholder="Please select an entry point">' +
            '{optionItem}' +
            '</select>' +
            '<div class="select" role="listbox">' +
            '<span class="value" data-bool="false">Please select an entry point</span>' +
            '<ul id="entryPointList" class="optList hidden" role="presentation">' +
            '<li class="option" data-option="enter" role="option" aria-selected="true">Please select an entry point</li>' +
            '{optionListItem}' +
            '</ul>' +
            '</div></div>';

        exitSelectTemplate = '<div id="exitPoint{inputId}" class="inputSelect hidden">' +
            '<label>Exit <div class="inputPin"><a href="#" class="exitPinLink">' + tollMap.ele.svg.routePin + '</a></div></label>' +
            '<select id="exitPoint" name="exitPoint" placeholder="Please select an exit point">' +
            '{optionItem}' +
            '</select>' +
            '<div class="select" role="listbox">' +
            '<span class="value" data-bool="false">Please select an exit point</span>' +
            '<ul id="exitPointList" class="optList hidden" role="presentation">' +
            '<li class="option" data-option="exit" role="option" aria-selected="true">Please select an exit point</li>' +
            '{optionListItem}' +
            '</ul>' +
            '</div></div>';

        // IMPORTANT! WILL NEED TO RE-EVAL THE PIN IN THE DROPDOWN IN FAV OF A EDIT ICON OR OTHER OPTION
        // an "X" might work
        // also need to make sure the entry option remains editable
        // other use cases/sites will clear the end pt when the start is changed
        // others add tooltip when clicked to confirm as a start or end pt

        // Add disclsaimer text to rightside of loading div, move icon and copy to leftside

        resultTemplate = '<div id="tollResult{resultId}" class="input-result">' +
            '<div class="result-loader hidden">' + tollMap.ele.svg.piggyBank +
            '<span class="loader-text">Calculating toll...</span>' +
            //'<img class="loader" src="/siteAssets/images/loader.gif" alt="Timer image" />' +
            '</div>' +
            '<div class="result-content hidden"><div class="result-bbm">' +
            '<span class="toll-label">Toll Invoice Rate</span>' +
            '<div class="toll-bbm"><span class="symbol-small">$</span>{tollBBM}</div>' +
            '</div>' +
            '<div class="result-ncqp">' +
            '<span class="toll-label">NC Quick Pass Rate*</span>' +
            '<div class="toll-ncqp"><span class="symbol-small">$</span>{tollNCQP}</div>' +
            '</div>' +
            '<div class="result-cta">' +
            '<div class="toll-save">Save <span class="savings-value">' + '<span class="symbol-small">$</span>{tollSavings}' + '</span>' +
            ' on this trip with a NC Quick Pass Account!' + tollMap.ele.svg.piggyBank + '</div>' +
            '<span class="disclaimer">*The NC Quick Pass rate is applicable to all NC Quick Pass accounts and partner agency transponders like E-ZPass, PeachPass and SunPass.</span>' +
            '</div></div></div>';

        // loop and build entry dropdown
        for (var i = 0; i < data.length; i++) {

            var entryOptions = '<option value="{optionValue}">{optionString}</option>',
                entryOptionListItems = '<li class="option" data-option="enter" role="option">{optionListItem}</li>';

            if (data[i].metadata.exitId && data[i].metadata.exitName) {

                entryOptions = entryOptions.replace('{optionValue}', data[i].metadata.exitId)
                    .replace('{optionString}', data[i].metadata.exitName);
                entryOptionListItems = entryOptionListItems.replace('{optionListItem}', data[i].metadata.exitName);
                selectItems.push(entryOptions);
                listItems.push(entryOptionListItems);
            }
        }
        entrySelectTemplate = entrySelectTemplate.replace('{inputId}', title.replace(/\s+/g, ''))
            .replace('{optionItem}', selectItems.join(''))
            .replace('{optionListItem}', listItems.join(''));

        // loop and build exit dropdown
        for (var j = 0; j < data.length; j++) {

            var exitOptions = '<option value="{optionValue}">{optionString}</option>',
                exitOptionListItems = '<li class="option" data-option="exit" role="option">{optionListItem}</li>';

            if (data[j].metadata.exitId && data[j].metadata.exitName) {

                exitOptions = exitOptions.replace('{optionValue}', data[j].metadata.exitId)
                    .replace('{optionString}', data[j].metadata.exitName);
                exitOptionListItems = exitOptionListItems.replace('{optionListItem}', data[j].metadata.exitName);
                exitSelectItems.push(exitOptions);
                exitListItems.push(exitOptionListItems);
            }
        }
        exitSelectTemplate = exitSelectTemplate.replace('{inputId}', title.replace(/\s+/g, ''))
            .replace('{optionItem}', exitSelectItems.join(''))
            .replace('{optionListItem}', exitListItems.join(''));

        // add title to result container id
        resultTemplate = resultTemplate.replace('{resultId}', title.replace(/\s+/g, ''));

        /*
        // pass the title and templates into the BM infobox via htmlContent option ** THIS STOPPED FUNCTIONING!!!
        tollPanel = new api.Maps.Infobox(loc, {
            htmlContent: tollPanelTemplate.replace('{title}', title)
            .replace('{entrySelects}', entrySelectTemplate)
            .replace('{exitSelects}', exitSelectTemplate)
            .replace('{result}', resultTemplate)
        });
        // add the infobox to the map
        tollPanel.setMap(map);
        */
        zoneIcon = (title == tollMap.ele.routeName.monExp) ? tollMap.ele.svg.zonePinMon : tollMap.ele.svg.zonePinTri;

        // pass the title and templates into a non-bing map infobox
        tollPanel = tollPanelTemplate.replace('{title}', title)
            //.replace('{zoneIcon}', zoneIcon)
            .replace('{entrySelects}', entrySelectTemplate)
            .replace('{exitSelects}', exitSelectTemplate)
            .replace('{result}', resultTemplate);

        // add the infobox the js way before the map
        tollMap.ele.mapDiv.insertAdjacentHTML('beforebegin', tollPanel);
        // fade in the panel
        panel = document.querySelector('.customInfobox');
        fadeIn(panel);
        // set dropdown features
        tollMap.setDropdowns(map, data);
        // add reset event here after sDD()
        resetBtn = document.getElementById('resetToll');
        resetBtn.addEventListener('click', function(e) {
            e.preventDefault();
            tollMap.resetMap(e);
        });
    },
    setDropdowns: function(map, data) {
        // log('setDropdowns called from createTollPanel');
        //log(data); // this is still the exitPin array data
        // build input/dropdowns for vehicle class, entry, and exit data

        // Event binding for select boxes
        var form = document.querySelector('form.no-widget'),
            selectList = document.querySelectorAll('.select'),
            vehicleClassList = document.getElementById('vehicleClassList');

        // if js enabled, then no-widget gets removed
        form.classList.remove('no-widget');
        form.classList.add('widget');

        // initialize each widget
        selectList.forEach(function(select) { // containing div with select element passed in

            var optionList = select.querySelectorAll('.option'), // li
                value = document.querySelector('.value'), // span
                selectedIndex = getIndex(select); // index from the native select ele
            select.tabIndex = 0; // make custom widget focusable (this is why moved opt val of placeholder to this pos in optList)
            select.previousElementSibling.tabIndex = -1; // make native select ele unfocusable
            // updates as soon as sDD is called - to make sure default selected value is correctly displayed
            updateValue(select, selectedIndex);

            // then loops thru each li option and sets e listeners
            optionList.forEach(function(option, index) { // li
                option.addEventListener('click', function(e) {
                    // could put entry check here with
                    highlightOption(select, option);

                    updateValue(select, index); // update the value when user clicks
                    select.classList.add('complete');
                    select.querySelector('.optList').classList.add('hidden');

                    // does not apply to vehicleClass so need to filter it out
                    // log('Me in a ' + e.target.parentElement.id);
                    // could also add ||
                    if (e.target.parentElement.id == 'vehicleClassList') {
                        // now show the entry input
                        window.setTimeout(function() {
                            var entrySelect = document.querySelector('.inputSelect.hidden');
                            entrySelect.classList.remove('hidden');
                        }, 300);
                        // see if can make the svg target = to its parent
                        // log(e.target.innerText);
                    }
                    // if eTL is not created yet & target is not the vc list, then target is entryPointList
                    if (tollMap.data.expTollLayer == null && e.target.parentElement.id != 'vehicleClassList') {
                        // match the target with option from exit list options and hide it
                        var exitOptionList = document.querySelectorAll('#exitPointList > .option');
                        if (e.target.parentElement.id == 'entryPointList') {
                            for (var i = 0; i < exitOptionList.length; i++) {
                                // if target option matches
                                if (e.target.innerText == exitOptionList[i].innerText) {
                                    exitOptionList[i].classList.add('hidden');
                                }
                            }
                        }
                        tollMap.setTollStart(e, Microsoft, map);

                    } else if (tollMap.data.expTollLayer != null) { // the eTL is not null once sTS() fires
                        tollMap.setTollEnd(e, Microsoft);
                    }

                });

            });

            select.addEventListener('click', function(e) {
                if(select.classList.contains('complete')) {
                    return;
                }
                toggleOptList(select); // toggle list of options
            });
            select.addEventListener('focus', function(e) {
                if(select.classList.contains('complete')) {
                    return;
                }
                activeSelect(select, selectList);
            });
            select.addEventListener('blur', function(e) {
                deactivateSelect(select);
            });
        });

        // also need to update the class of 'highlight' in the selected li
        // how bout adding data-state='entry', or 'exit', or 'selected'

        // Function definitions for select boxes
        function deactivateSelect(select) { // select : the DOM node with the `select` class to deactivate - div
            if (!select.classList.contains('active')) return; // if widget is not active, do nothing
            var optList = select.querySelector('.optList'); // ul
            optList.classList.add('hidden'); // ul hidden in initial state
            select.classList.remove('active');
        }
        // turn on active state on a custom widget
        function activeSelect(select, selectList) { // select (see above)  selectList : all DOM nodes with the `select` class
            if (select.classList.contains('active')) return; // if widget is active, do nothing
            selectList.forEach(deactivateSelect); // containing div - turn off active state on all custom widgets
            select.classList.add('active'); // turn on the active state for this specific widget
        }
        // toggle the optList's visability
        function toggleOptList(select, show) { // select : the DOM node with the list to toggle
            var optList = select.querySelector('.optList'); // ul
            optList.classList.toggle('hidden'); // change class to show or hide
        }
        // highlight an option
        function highlightOption(select, option) { // option : the DOM node with the `option` class to highlight
            var optionList = select.querySelectorAll('.option'); // li
            optionList.forEach(function(other) {
                other.classList.remove('highlight'); // remove highlight from all options
            });
            option.classList.add('highlight'); // highlight specific option
        }
        // was goiung to be how to disable matching list item styles etc
        function disableOption(select, option) { // select, option should be the exit widget
            var optionList = select.querySelectorAll('.option'), // li
                entryOptionList = select.querySelectorAll('.option'); // entry list li
            // if entry list contains or classlist highlight?
            optionList.forEach(function(other) { //
                //if(optionList.getAttribute('data-option') == "enter"){
                //option.setAttribute('disabled');

                //}
                //other.setAttribute('disabled', ''); is this what will remove it?
            });
            //option.setAttribute('disabled');
        }

        function updateValue(select, index) { // select : the DOM node with class `select` holding the value to update
            var nativeWidget = select.previousElementSibling; // sibling is the select ele
            var value = select.querySelector('.value'); // span - get spans value
            var optionList = select.querySelectorAll('.option'); // li - list of options
            optionList.forEach(function(other) { // make sure options are not selected
                other.setAttribute('aria-selected', 'false');
            });
            optionList[index].setAttribute('aria-selected', 'true'); // update the selected option
            nativeWidget.selectedIndex = index; // set select index to one chosen in optList
            value.innerHTML = optionList[index].innerHTML; // update the span value
            highlightOption(select, optionList[index]); // highlight option of custom widget
        }

        function getIndex(select) { // select : the DOM node with class `select` related to the native widget
            var nativeWidget = select.previousElementSibling; // sibling is the select ele
            return nativeWidget.selectedIndex; // returns current selected index in native select
        }
    },
    setTollStart: function(e, api, map) {
        // log('setTollStart called from setExpPinsPolys or setDropdowns');
        //log(e.target); // event holds target/data from the expExitDataLayer which was split into layers previously

        var startFlag = null,
            mouseOutEnd, endClick;
        startPinLink = document.querySelector('.entryPinLink');
        // create new layer called 'expTollLayer' to add the startPt, endPt pins, and tollPolyline
        if (tollMap.data.expTollLayer == null) {
            tollMap.data.expTollLayer = new api.Maps.Layer('ExpTollLayer');
            map.layers.insert(tollMap.data.expTollLayer);
        }
        // if event is from select list, then no metadata/location, match them up here
        if (!e.target.metadata) {
            // log('not a layer');
            var listTarget = e.target,
                listData = tollMap.data.expExitDataLayer.getPrimitives();

            for (var i = 0; i < listData.length; i++) {
                if (listTarget.innerText == listData[i].metadata.exitName) {
                    listTarget = listData[i];
                    listTarget.setOptions({
                        icon: tollMap.ele.svg.startPin,
                    });
                    startFlag = new api.Maps.Pushpin(listTarget.getLocation(), {
                        icon: tollMap.ele.svg.startFlag,
                        anchor: new api.Maps.Point(120, 16),
                    });
                }
            }
            // should a filter go here to match the target location?
            tollMap.data.expTollLayer.add(listTarget);
            tollMap.data.expTollLayer.add(startFlag);
        } else if (e.target.metadata) {
            startFlag = new api.Maps.Pushpin(e.target.getLocation(), {
                icon: tollMap.ele.svg.startFlag,
                anchor: new api.Maps.Point(120, 16),
            });
            // may revisit this later
            api.Maps.Events.addHandler(e.target, 'mouseout', function(e) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.startPin,
                });
            });
            tollMap.data.expTollLayer.add(e.target);
            tollMap.data.expTollLayer.add(startFlag);
        }
        // make the select list pin green
        startPinLink.innerHTML = tollMap.ele.svg.startPin;
        // unhide the exitSelect html
        window.setTimeout(function() {
            var exitSelect = document.querySelector('#exitPointTriangleExpressway,#exitPointMonroeExpressway');
            exitSelect.classList.remove('hidden');
        }, 300);

        // setup endPin hover state after startPin has been selected
        if (tollMap.data.expTollLayer != null && tollMap.data.expTollLayer.getPrimitives() != e.target) {
            // remove start related handlers
            api.Maps.Events.removeHandler(startClick);

            //if(tollMap.data.expTollLayer != null) {
            // need to prevent the match case from happening... != e.target, the previous one
            // if(tollMap.data.expTollLayer primitives are < 2) aka no more than two prims on layer (pin and flag)

            // if opt list then need to reset span val here
            // orig mouseOver still works and if initial pin selection is from optList then this resets both values
            // mouseOver actually is operating in the entryPoint list (its gaining focus) with this specific case
            mouseOutEnd = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'mouseout', function(e) {
                e.target.setOptions({
                    icon: tollMap.ele.svg.routePin,
                    title: '',
                });
            });
            // with above use case, this will populate both fields with the clicked value
            endClick = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'click', function(e) {
                var exitOptList = document.getElementById('exitPointList'),
                    exitOptionList = document.querySelectorAll('#exitPointList > .option');

                api.Maps.Events.removeHandler(mouseOutEnd);

                if(tollMap.exitSelected) {
                    return;
                }

                e.target.setOptions({
                    icon: tollMap.ele.svg.endPin,
                    title: '',
                });

                if (exitOptList.previousElementSibling.dataset.bool == 'false') { // if span attr val = false
                    exitOptList.classList.add('hidden');
                    exitOptList.parentNode.classList.add('complete');

                    exitOptionList.forEach(function(option, index) { // li for each ul

                        if (e.target.metadata.exitName == option.innerText && option.dataset.option == 'exit') {
                            exitOptList.previousElementSibling.innerText = option.innerText; // updates the span value
                            exitOptList.previousElementSibling.dataset.bool = 'true'; // update its data-bool
                        }
                    });
                }
                tollMap.setTollEnd(e, Microsoft);
            });
        }
    },
    setTollEnd: function(e, api) {
        // log('setTollEnd called from setTollStart');
        // log(e.target);
        // calls setTollRoute()
        // calls calculateToll() immediately, and should be able to get called more than once
        // add event handler for change events to updateToll()

        if (tollMap.exitSelected) {
            // log('exit already selected');
            return;
        }
        tollMap.exitSelected = true;

        var endFlag = null,
            endPinLink = document.querySelector('.exitPinLink'),
            mouseOverUpdate;

        if (!e.target.metadata) {
            var listTarget = e.target,
                listData = tollMap.data.expExitDataLayer.getPrimitives();

            for (var i = 0; i < listData.length; i++) { // loop thru eEDL pins
                if (listTarget.innerText == listData[i].metadata.exitName) { // if opt matches eEDL pin metadata
                    //log('working: ' + i + ' - ' + listTarget.innerText);
                    listTarget = listData[i]; // set target to the matching pin
                    listTarget.setOptions({
                        icon: tollMap.ele.svg.endPin,
                    }); // add style
                    endFlag = new api.Maps.Pushpin(listTarget.getLocation(), { // add a flag
                        icon: tollMap.ele.svg.endFlag,
                        anchor: new api.Maps.Point(120, 16),
                    });
                }
                // style in-between pins here - DOES NOT APPLY TO SELECTION FROM eEDL
                if (listTarget.innerText != listData[i].metadata.exitName) { // if opt != eEDL pin metadata
                    // if eTL is truthy and eTL pins != e target (end pt chosen from optList)
                    if (tollMap.data.expTollLayer != null && tollMap.data.expTollLayer.getPrimitives() != e.target) {

                        //log('working: ' + i + ' - ' + listTarget.innerText); // logs options text up to end pt which = undefined
                        //log('working: ' + i + ' - ' + listData[i].metadata.exitName);
                        if (listTarget.innerText != undefined) {
                            //listData[i].setOptions({ icon: tollMap.ele.svg.startPin });
                        }

                    }
                }
            }
            tollMap.data.expTollLayer.add(listTarget);
            tollMap.data.expTollLayer.add(endFlag);
        } else if (e.target.metadata && tollMap.data.expTollLayer.getPrimitives() != e.target) {
            e.target.setOptions({
                icon: tollMap.ele.svg.endPin,
            });
            endFlag = new api.Maps.Pushpin(e.target.getLocation(), {
                icon: tollMap.ele.svg.endFlag,
                anchor: new api.Maps.Point(120, 16),
            });
            tollMap.data.expTollLayer.add(e.target);
            tollMap.data.expTollLayer.add(endFlag);
        }
        // make the select list pin red
        endPinLink.innerHTML = tollMap.ele.svg.endPin;
        // unhide the resultContent html. resultLoader will go first then get hidden again
        window.setTimeout(function() {
            var resultLoader = document.querySelector('.result-loader.hidden');
            resultLoader.classList.remove('hidden');
        }, 100);
        window.setTimeout(function() {
            var resultContent = document.querySelector('.result-content.hidden'),
                resultLoader = document.querySelector('.result-loader');
            resultLoader.classList.add('hidden');
            resultContent.classList.remove('hidden');
            fadeIn(resultContent);
        }, 2000);
        // animation mentioned below may have to happen here and separate from the poly animation
        tollMap.setTollRoute(e, Microsoft);
        // pass toll data into getTollData based on routeName
        if (tollMap.data.expTollLayer._primitives[0].metadata.routeName == tollMap.ele.routeName.monExp) {
            tollMap.getTollData(e, tollMap.data.monExpTollJson);
        } else if (tollMap.data.expTollLayer._primitives[0].metadata.routeName == tollMap.ele.routeName.triExp) {
            tollMap.getTollData(e, tollMap.data.triExpTollJson);
        }

        // if (cT() has run) add e handler to call uT(), or if results panel is truthy?
        // or rates are displayed?
        mouseOverUpdate = api.Maps.Events.addHandler(tollMap.data.expExitDataLayer, 'mouseover', function(e) {
            api.Maps.Events.removeHandler(mouseOver);
            //api.Maps.Events.removeHandler(endClick); // why is this not defined? cuz its the e that was passed in?
            e.target.setOptions({
                icon: tollMap.ele.svg.routePin,
            });
            tollMap.updateToll(e, Microsoft);
        });
    },
    setTollRoute: function(e, api) {
        // log('setTollRoute called from setTollEnd');
        //log(e.target); // either a pin or a list item
        //log(tollMap.data.expExitDataLayer.getPrimitives());
        //log(tollMap.data.expDataLayer.getPrimitives());

        var expData = tollMap.data.expExitDataLayer.getPrimitives(),
            routeData = tollMap.data.expDataLayer.getPrimitives(),
            tempRouteData = [],
            target;

        // BM has areEqual(), clone(), parseLatLong(string) as possibilities for converting

        // might use well known text to read coords from linestring and draw as polyline
        // what about directions module?? waypoint 1 waypoint 2...

        // try setting the target by using a conditional
        // would have to let pinTarget and listTarget
        //target = (tollArray[0].geometry.y < tollArray[1].geometry.y) ? "northbound" : "southbound";

        // getPrim from eEDL and dump into an array, or just loop through them
        // need to match pins metadata on both layers (eEDL and eTL) and then get the index value of the one on the eEDL
        // if(e.target.metadata.exitId == exitData[i].metadata.exitId) {  }
        // do it for start and end pts
        for (var i = 0; i < expData.length; i++) { // loop thru eEDL
            //log(e.target); // either a pin or a list item
            //log(e.target.layer._id);

            /*
                        if(expData[i] != e.target && e.target.layer._id != 'expTollLayer') { // if pin data != to the target & target layer = eEDL
                            log("not the target");
                            if(e.target.layer._id == 'expTollLayer') { // if
                                log("no not me");
                            } else {
                                expData[i].setOptions({ icon: tollMap.ele.svg.startPin });
                            }
                        }
            */
            /*if(expData[i].entryPoint != tollArray[0].metadata.exitName && expData[i].exitPoint != tollArray[1].metadata.exitName) {
                if(!entryZone) {
                    log("not this zone, " + expData[i].tollZone);
                } else if(entryZone && !exitZone) {
                    //log("this zone is in, " + eastBound[j].tollZone);
                    tollRateJson.push(eastBound[j]);
                }
            }*/

            //if(expData[i].metadata.exitId && i < e.target.getIndex()) {
            //  expData[i].setOptions({
            //      icon: tollMap.ele.svg.routePin
            //  });
            //}

        }
        // have to look at geometry and see if x (or y) value is good enough to get in-between coords
        // once have in-between stuff, likely has to go into new var'd array, made into new poly to get pushed and styled
        // might be problematic to create and recreate the poly in a hover-fired event state
        for (var j = 0; j < routeData.length; j++) {
            //routeData[j].setOptions({
            //  strokeColor: tollMap.style.color.ncqpGreen,
            //  strokeThickness: 5 // will only work if on new layer
            //});

            //if(routeData[j] != e.target) {
            //  routeData[j].setOptions({ icon: tollMap.ele.svg.startPin });
            //}

        }

        // tollMap.data.EXP.features.geometry.type == 'LineString'

        // does it make sense to start by cloning the eDL ?
        // start with a clean up pass on the cloned layer to remove gantryPins?


        // MIGHT BE BEST IF ABLE TO LEAVE THE ROUTEDATA ON ITS EXISTING LAYER AND JUST RESTYLE IT
        // this may not make much sense

        // THIS WOULD BE REALLY COOL IF IT ANIMATED A POLY/PIN CHANGE UPTO THE TARGET BEING HOVERED!!!
        // AND DISAPPEARED ON MOUSEOUT
        // might loop through pins and use a setTimeout with a 100 millisecond step for each change over
        // maybe pins do this and poly fades in once endPin is clicked

        // need to loop thru the layer primitives, create a var which holds empty array, add in between items to the array
        // once the pins/data has been displayed, array needs to be cleared or destroyed or reset? for the next iterations

        // The poly might require capturing all linestring coords between said range of coords from each (start and end) pin locations


    },
    getTollData: function(e, data) {
        // log('getTollData called from setTollEnd');

        var tollPoints = tollMap.data.expTollLayer.getPrimitives(),
            routeDirection, tollArray = [],
            tollRateJson = [];
        // log(tollPoints); // start/end pts are in here with flags
        //log(e.target);

        for (var i = 0; i < tollPoints.length; i++) {
            if (tollPoints[i].metadata) {
                //push pts to the array removing flags
                tollArray.push(tollPoints[i]);
            }
        }
        // log(tollArray);
        // compare coords to establish direction
        if (tollArray[0].metadata.routeName == tollMap.ele.routeName.monExp) {
            routeDirection = (tollArray[0].geometry.x < tollArray[1].geometry.x) ? 'eastbound' : 'westbound';
        } else {
            routeDirection = (tollArray[0].geometry.y < tollArray[1].geometry.y) ? 'northbound' : 'southbound';
        }

        // match pin direction to data direction
        switch (routeDirection) {
            case 'eastbound': // pin direction is east
                var eastBound = data.routeDir.eastbound; // json order matches eastbound dir
                if (eastBound) { // if json data direction is east
                    // loop through json array
                    for (var j = 0; j < eastBound.length; j++) {
                        var entryZone, exitZone;
                        // if json array entry matches pin metadata
                        if (eastBound[j].entryPoint == tollArray[0].metadata.exitName) { // matches start pt
                            entryZone = eastBound[j].tollZone; // set pt tollZone val = to entryZone
                            tollRateJson.push(eastBound[j]); // push it to the array
                        }
                        // if json array exit matches pin metadata
                        if (eastBound[j].exitPoint == tollArray[1].metadata.exitName) { // matches end pt
                            exitZone = eastBound[j].tollZone; // set pt tollZone val = to exitZone
                            if (entryZone === exitZone) { // if they match, only one tollZone, only entry gets pushed to array
                                // log('I be the same dude');
                            } else {
                                // log('end pt, ' + eastBound[j].exitPoint);
                                tollRateJson.push(eastBound[j]); // push it to the array
                            }
                        }
                        // if json array doesn't match pin metadata
                        if (eastBound[j].entryPoint != tollArray[0].metadata.exitName && eastBound[j].exitPoint != tollArray[1].metadata.exitName) {
                            if (!entryZone) {
                                // log('not this zone, ' + eastBound[j].tollZone);
                            } else if (entryZone && !exitZone) {
                                tollRateJson.push(eastBound[j]);
                            }
                        }
                    }
                }
                break;
            case 'westbound':
                var westBound = data.routeDir.westbound.slice().reverse();
                if (westBound) {
                    for (var k = 0; k < westBound.length; k++) {
                        var entryZone, exitZone;

                        if (westBound[k].entryPoint == tollArray[0].metadata.exitName) {
                            entryZone = westBound[k].tollZone;
                            tollRateJson.push(westBound[k]);
                        }
                        if (westBound[k].exitPoint == tollArray[1].metadata.exitName) {
                            exitZone = westBound[k].tollZone;
                            if (entryZone === exitZone) {} else {
                                tollRateJson.push(westBound[k]);
                            }
                        }
                        if (westBound[k].entryPoint != tollArray[0].metadata.exitName && westBound[k].exitPoint != tollArray[1].metadata.exitName) {
                            if (!entryZone) {} else if (entryZone && !exitZone) {
                                tollRateJson.push(westBound[k]);
                            }
                        }
                    }
                }
                break;
            case 'northbound':
                var northBound = data.routeDir.northbound;
                if (northBound) {
                    for (var l = 0; l < northBound.length; l++) {
                        var entryZone, exitZone;
                        if (northBound[l].entryPoint == tollArray[0].metadata.exitName) {
                            entryZone = northBound[l];
                            exitZone = entryZone.exitPoint;
                            for (var m = 0; m < exitZone.length; m++) {
                                if (exitZone[m] == tollArray[1].metadata.exitName) {
                                    // log('exit stage toll, ' + exitZone[m] + ', ' + m);
                                    tollRateJson.push(entryZone.tollRateTA[m], entryZone.tollRateBBM[m], entryZone.tollRateSavings[m]);
                                }
                            }
                        }
                    }
                }
                break;
            case 'southbound':
                var southBound = data.routeDir.southbound;
                if (southBound) {
                    for (var n = 0; n < southBound.length; n++) {
                        var entryZone, exitZone;
                        if (southBound[n].entryPoint == tollArray[0].metadata.exitName) {
                            entryZone = southBound[n];
                            exitZone = entryZone.exitPoint;
                            for (var o = 0; o < exitZone.length; o++) {
                                if (exitZone[o] == tollArray[1].metadata.exitName) {
                                    // log('exit stage toll, ' + exitZone[o] + ', ' + o);
                                    tollRateJson.push(entryZone.tollRateTA[o], entryZone.tollRateBBM[o], entryZone.tollRateSavings[o]);
                                }
                            }
                        }
                    }
                }
                break;
        }
        // log('gonna calc somethin');
        // log(tollRateJson);
        tollMap.calculateToll(e, tollRateJson);

    },
    calculateToll: function(e, data) {
        // log('calculateToll called from getTollData');
        // log(data);

        var tollRate = [],
            tollRateBbm = [],
            tollSavings = [],
            vehicleClass = 'one',
            vehicleClassLi = document.querySelectorAll('#vehicleClassList .option'),
            vcOneRateBbm = null,
            vcOneRate = null,
            vcOneSave = null,
            vcTwoRate = 2,
            vcThreeRate = 4,
            tollResult = document.querySelector('.toll-ncqp'),
            tollResultBbm = document.querySelector('.toll-bbm'),
            tollResultSave = document.querySelector('.savings-value');

        // loop through data and add each rate to its own array to be summed
        if (tollMap.data.expTollLayer._primitives[0].metadata.routeName == tollMap.ele.routeName.monExp) {
            // log('monExp in the cT');
            for (var i = 0; i < data.length; i++) {
                if (data[i].length < 2) {
                    // log('I am only 1 length old');
                    let sum = data[0].tollRateTA;
                    let sumBbm = data[0].tollRateBBM;
                    let sumSave = data[0].tollRateSavings;
                } else {
                    tollRate.push(data[i].tollRateTA);
                    tollRateBbm.push(data[i].tollRateBBM);
                    tollSavings.push(data[i].tollRateSavings);
                }

            }
            const add = (a, b) => a + b;
            let sum = tollRate.reduce(add);
            let sumBbm = tollRateBbm.reduce(add);
            let sumSave = tollSavings.reduce(add);

            vcOneRate = sum;
            vcOneRateBbm = sumBbm;
            vcOneSave = sumSave;

        } else if (tollMap.data.expTollLayer._primitives[0].metadata.routeName == tollMap.ele.routeName.triExp) {
            // log('triExp in the cT');

            let sum = data[0];
            let sumBbm = data[1];
            let sumSave = data[2];

            vcOneRate = sum;
            vcOneRateBbm = sumBbm;
            vcOneSave = sumSave;
        }

        // match the selected vehicle class
        if (vehicleClassLi[1].classList.contains('highlight')) {
            vehicleClass = 'two';
        }
        if (vehicleClassLi[2].classList.contains('highlight')) {
            vehicleClass = 'three';
        }

        // once toll rate array values are reduced, make calc dependant on chosen vehicle class
        switch (vehicleClass) {
            case 'two':
                tollRate = vcOneRate;
                tollRate *= vcTwoRate;
                tollRateBbm = vcOneRateBbm;
                tollRateBbm *= vcTwoRate;
                tollSavings = vcOneSave;
                tollSavings *= vcTwoRate;
                // log('2 be like, ' + tollRate);
                break;
            case 'three':
                tollRate = vcOneRate;
                tollRate *= vcThreeRate;
                tollRateBbm = vcOneRateBbm;
                tollRateBbm *= vcThreeRate;
                tollSavings = vcOneSave;
                tollSavings *= vcThreeRate;
                // log('i love 3, ' + tollRate);
                break;
            default:
                tollRate = vcOneRate;
                tollRateBbm = vcOneRateBbm;
                tollSavings = vcOneSave;
                break;
        }

        // replace rate result in the tollPanel
        tollResult.lastChild.textContent = tollRate.toFixed(2);
        tollResultBbm.lastChild.textContent = tollRateBbm.toFixed(2);
        tollResultSave.lastChild.textContent = tollSavings.toFixed(2);
        // log('The NC Quick Pass rate is $' + tollRate.toFixed(2) + ' and the Toll Invoice Rate is $' + tollRateBbm.toFixed(2));

        // should a conditional be used to check for a calc'd toll, if its false then do nothing?
        // if true load the result?
        // create a boolean value upon successful calc, so updateToll can know if truthy

        // once tolls are calc'd, look for the vehicle class multiplier and adjust if nec

        // after calc, add event handlers here to update the toll
        // if another option selected from entry DD --> clear exit DD --> uT();
        // if another option selected from exit DD --> uT();
        // else if (newPinClick toolTip choice == start) isNewStart : isNewEnd --> uT();



        //return;

    },
    updateToll: function(e, api) {
        // log('updateToll called from setTollEnd event handler');
        // may be separate functions depending on what's being changed
        // changing vehicle class can update the toll rate via a simple math, ie 'tollrate * 2'
        // changing a pin requires finding the new value and replacing, etc

        // if expTollLayer exists and primtives.length =4 and a toll calculation == true
        // loop through and check if new target matches others, or if its on the toll layer
        // if not then replace end pin and recalulate toll

        // is this a one time event?
        // should a reset here only clear the expTollLayer, so as to not lose the current toll zone?

        // this should call cT() once new selections have been made

    },
    resetMap: function(e) {
        // log('resetMap fired from setExpMap event');
        jQuery('#toll-route').show();
        jQuery('#toll-route').val('');
        //log(e);
        // NOTE: MAKE SURE TO TURN THIS RESET OFF WHEN PIN SELECTION EVENTS FIRE
        // SHOULD ALL event handlers be removed here too?
        // layer methods from BM...clear(), dispose(), remove(primitive), removeAt(index), setPrimitives(), getPrimitives()

        tollMap.exitSelected = false;

        if ((e.targetType == 'map' || e.target.nodeName == 'A') && tollMap.data.zonePinLayer.getVisible() == false) {

            var infoboxContainer = document.querySelector('.customInfobox'),
                iconContainer = document.querySelector('.zone-icon');
            if (infoboxContainer != null) {
                infoboxContainer.parentNode.removeChild(infoboxContainer);
            }
            //if(iconContainer != null) {
            //  iconContainer.parentNode.removeChild(iconContainer);
            //}

            tollMap.data.zonePinLayer.setVisible(true);
            if (tollMap.data.expTollLayer != null) {
                this.map.layers.remove(tollMap.data.expTollLayer);
                tollMap.data.expTollLayer = null;
            }
            this.map.layers.remove(tollMap.data.expDataLayer);
            tollMap.data.expDataLayer = null;
            this.map.layers.remove(tollMap.data.expExitDataLayer);
            tollMap.data.expExitDataLayer = null;

            tollMap.map.setView({
                zoom: 8,
                center: new Microsoft.Maps.Location(tollMap.location.lat, tollMap.location.long),
            });
            //log(this.map.layers);

        }
        // this became truthy so now it fires too...both of them fire
        // this is meant to stop a reset on the initial map
        // is this a delegation issue??
        else if (e.targetType == 'map' && tollMap.data.zonePinLayer.getVisible() == true) {
            //log("do something to map");
        }
        //else if(e.targetType == 'map' && e.eventName == 'dragend') {
        //e.handled = true;
        //log("sorry mr map");
        //}
    },
    init: function(api) {
        this.api = api;
        this.loadMap();
    },
};

function loadMapScenario() {
    setTimeout(() => {
        tollMap.init(Microsoft);
    }, 500)
}
// should just add the callback to the bing map call
document.addEventListener('DOMContentLoaded', function() {
    // Bail early if no map div.
    if (!document.getElementById('mapholder')) {
        return;
    }

    loadMapScenario();

    const TOLL_ROUTE_DROPDOWN = jQuery('#toll-route');
    const TOLL_ROUTE_INFORMATION = jQuery('#toll-route-information');

    TOLL_ROUTE_DROPDOWN.on('change', function() {
        const VALUE = jQuery(this).val();
        TOLL_ROUTE_INFORMATION.hide();

        if (VALUE === 'monroe') {
            tollMap.data.zonePinLayer.setVisible(false);
            jQuery(this).hide();
            window.setTimeout(function() {
                let monPinLoc = new Microsoft.Maps.Location(tollMap.location.monExp.lat, tollMap.location.monExp.lon);
                tollMap.map.setView({
                    zoom: 11,
                    center: monPinLoc,
                    centerOffset: new Microsoft.Maps.Point(-25, 0),
                });
                tollMap.setExpPinsPolys(Microsoft, tollMap.map, tollMap.data.monExpGeoJson);
            }, 100);
        }

        if (VALUE === 'triangle') {
            tollMap.data.zonePinLayer.setVisible(false);
            jQuery(this).hide();
            window.setTimeout(function() {
                let triPinLoc = new Microsoft.Maps.Location(tollMap.location.triExp.lat, tollMap.location.triExp.lon);
                tollMap.map.setView({
                    zoom: 11,
                    center: triPinLoc,
                    centerOffset: new Microsoft.Maps.Point(-15, 0),
                });
                tollMap.setExpPinsPolys(Microsoft, tollMap.map, tollMap.data.triExpGeoJson);
            }, 100);
        }

        if (VALUE === 'i77') {
            TOLL_ROUTE_INFORMATION.show();
        }
    })
});
